/**
 * 🎨 Asset Types
 *
 * Asset CodeGen에 의해 자동 생성된 TypeScript 타입 정의
 *
 * @package stepin-website-tournament
 */

import React from 'react';

/**
 * Asset 이름 타입
 * 모든 사용 가능한 Asset의 이름을 포함합니다 (name-extension 형식)
 */
export type AssetName =
	| 'auth-action-checkbox-active-svg'
	| 'auth-action-checkbox-default-black-svg'
	| 'auth-action-checkbox-default-white-svg'
	| 'auth-action-clear-gray-svg'
	| 'auth-action-clear-purple-active-svg'
	| 'auth-action-clear-purple-default-svg'
	| 'auth-action-clear-red-svg'
	| 'auth-action-code-active-svg'
	| 'auth-action-code-default-svg'
	| 'auth-action-confirm-password-active-svg'
	| 'auth-action-confirm-password-default-svg'
	| 'auth-action-email-active-svg'
	| 'auth-action-email-default-svg'
	| 'auth-action-password-active-svg'
	| 'auth-action-password-default-svg'
	| 'auth-chevron-right-svg'
	| 'auth-icon-arcade-logo-png'
	| 'auth-icon-arcade-logo-with-speaker-png'
	| 'auth-icon-globe-svg'
	| 'auth-icon-stepin-logo-png'
	| 'icon-3D-energy-1-png'
	| 'icon-3D-energy-2-png'
	| 'icon-3D-energy-3-png'
	| 'icon-3D-energy-4-png'
	| 'icon-3D-energy-5-png'
	| 'icon-3D-energy-6-png'
	| 'icon-3D-image-banner-png'
	| 'icon-3D-image-cash-png'
	| 'icon-3D-image-date-png'
	| 'icon-3D-image-diamond-png'
	| 'icon-3D-image-global-png'
	| 'icon-3D-image-lock-png'
	| 'icon-3D-image-notice-png'
	| 'icon-3D-image-poster-png'
	| 'icon-3D-image-song-list-png'
	| 'icon-3D-image-song-png'
	| 'icon-3D-image-text-png'
	| 'icon-3D-image-unlock-png'
	| 'icon-GNB-announcement-svg'
	| 'icon-GNB-gnb-svg'
	| 'icon-GNB-inbox-svg'
	| 'icon-GNB-meatball-svg'
	| 'icon-GNB-mission-svg'
	| 'icon-GNB-notice-svg'
	| 'icon-GNB-setting-svg'
	| 'icon-action-account-invite-svg'
	| 'icon-action-account-withdrawal-svg'
	| 'icon-action-attendance-svg'
	| 'icon-action-bookmark-purple-active-svg'
	| 'icon-action-bookmark-purple-default-svg'
	| 'icon-action-bookmark-white-active-svg'
	| 'icon-action-bookmark-white-default-svg'
	| 'icon-action-box-disabled-svg'
	| 'icon-action-box-enabled-svg'
	| 'icon-action-business-svg'
	| 'icon-action-change-biz-enabled-svg'
	| 'icon-action-change-biz-hover-svg'
	| 'icon-action-change-biz-pressed-svg'
	| 'icon-action-change-default-enabled-svg'
	| 'icon-action-change-default-hover-svg'
	| 'icon-action-change-default-pressed-svg'
	| 'icon-action-check-black-active-svg'
	| 'icon-action-check-black-default-svg'
	| 'icon-action-check-gray-svg'
	| 'icon-action-checkbox-l-active-svg'
	| 'icon-action-checkbox-l-default-svg'
	| 'icon-action-checkbox-s-active-svg'
	| 'icon-action-checkbox-s-default-svg'
	| 'icon-action-chevron-circle-white-left-disabled-svg'
	| 'icon-action-chevron-circle-white-left-enabled-svg'
	| 'icon-action-chevron-circle-white-left-svg'
	| 'icon-action-chevron-circle-white-right-disabled-svg'
	| 'icon-action-chevron-circle-white-right-enabled-svg'
	| 'icon-action-chevron-circle-white-right-svg'
	| 'icon-action-chevron-white-left-svg'
	| 'icon-action-chevron-white-right-svg'
	| 'icon-action-circle-active-svg'
	| 'icon-action-circle-default-svg'
	| 'icon-action-circle-l-active-svg'
	| 'icon-action-circle-l-default-svg'
	| 'icon-action-circle-s-active-svg'
	| 'icon-action-circle-s-default-svg'
	| 'icon-action-circle-svg'
	| 'icon-action-clear-gray-svg'
	| 'icon-action-clear-purple-svg'
	| 'icon-action-clear-white-svg'
	| 'icon-action-code-active-svg'
	| 'icon-action-code-default-svg'
	| 'icon-action-delete-active-svg'
	| 'icon-action-delete-default-svg'
	| 'icon-action-dropdown-black-down-svg'
	| 'icon-action-dropdown-black-up-svg'
	| 'icon-action-edit-pencil-svg'
	| 'icon-action-edit-stick-svg'
	| 'icon-action-email-active-svg'
	| 'icon-action-email-default-svg'
	| 'icon-action-exclude-black-svg'
	| 'icon-action-exclude-white-svg'
	| 'icon-action-floating-chat-default-1-svg'
	| 'icon-action-floating-chat-default-svg'
	| 'icon-action-floating-chat-hover-svg'
	| 'icon-action-floating-chat-svg'
	| 'icon-action-gnb-svg'
	| 'icon-action-inbox-active-svg'
	| 'icon-action-inbox-default-svg'
	| 'icon-action-inbox-t-active-svg'
	| 'icon-action-inbox-t-default-svg'
	| 'icon-action-kebab-black-svg'
	| 'icon-action-kebab-white-svg'
	| 'icon-action-language-active-svg'
	| 'icon-action-language-default-svg'
	| 'icon-action-language-hover-svg'
	| 'icon-action-language-svg'
	| 'icon-action-logout-active-svg'
	| 'icon-action-logout-default-svg'
	| 'icon-action-logout-hover-svg'
	| 'icon-action-meatball-black-svg'
	| 'icon-action-meatball-white-svg'
	| 'icon-action-meatballs-enabled-svg'
	| 'icon-action-meatballs-hover-svg'
	| 'icon-action-meatballs-pressed-svg'
	| 'icon-action-member-in-svg'
	| 'icon-action-member-out-svg'
	| 'icon-action-notice-active-svg'
	| 'icon-action-notice-default-svg'
	| 'icon-action-password-active-svg'
	| 'icon-action-password-default-svg'
	| 'icon-action-pause-hover-svg'
	| 'icon-action-pause-svg'
	| 'icon-action-play-black-svg'
	| 'icon-action-play-hover-svg'
	| 'icon-action-play-svg'
	| 'icon-action-playicon-challenge-svg'
	| 'icon-action-playicon-practice-svg'
	| 'icon-action-playicon-rpd-svg'
	| 'icon-action-practice-svg'
	| 'icon-action-refresh-black-svg'
	| 'icon-action-refresh-white-svg'
	| 'icon-action-remove-black-svg'
	| 'icon-action-remove-gray-svg'
	| 'icon-action-remove-purple-svg'
	| 'icon-action-remove-svg'
	| 'icon-action-remove-white-svg'
	| 'icon-action-report-active-svg'
	| 'icon-action-report-default-svg'
	| 'icon-action-report-hover-svg'
	| 'icon-action-rpd-svg'
	| 'icon-action-search-active-svg'
	| 'icon-action-search-challenge-svg'
	| 'icon-action-search-default-svg'
	| 'icon-action-search-purple-svg'
	| 'icon-action-search-white-svg'
	| 'icon-action-setting-active-svg'
	| 'icon-action-setting-default-svg'
	| 'icon-action-setting-enabled-svg'
	| 'icon-action-setting-hover-svg'
	| 'icon-action-setting-pressed-svg'
	| 'icon-action-setting-white-svg'
	| 'icon-action-settings-minus-svg'
	| 'icon-action-settings-plus-svg'
	| 'icon-action-skeleton-disabled-svg'
	| 'icon-action-skeleton-enabled-svg'
	| 'icon-action-speed-black-svg'
	| 'icon-action-stop-black-svg'
	| 'icon-action-suggest-biz-enabled-svg'
	| 'icon-action-suggest-biz-hover-svg'
	| 'icon-action-suggest-biz-pressed-svg'
	| 'icon-action-suggest-default-enabled-svg'
	| 'icon-action-suggest-default-hover-svg'
	| 'icon-action-suggest-default-pressed-svg'
	| 'icon-action-switch-black-svg'
	| 'icon-action-tooltip-gray-svg'
	| 'icon-action-tracking-svg'
	| 'icon-action-upload-purple-svg'
	| 'icon-action-upload-svg'
	| 'icon-bookmark-gray-disabled-svg'
	| 'icon-bookmark-gray-enabled-svg'
	| 'icon-bookmark-white-disabled-svg'
	| 'icon-bookmark-white-enabled-svg'
	| 'icon-calendar-dark-svg'
	| 'icon-calendar-gray-svg'
	| 'icon-calendar-white-svg'
	| 'icon-carousel-active-svg'
	| 'icon-carousel-default-svg'
	| 'icon-check-active-svg'
	| 'icon-check-enabled-svg'
	| 'icon-checkbox-purple-active-svg'
	| 'icon-checkbox-purple-enabled-svg'
	| 'icon-checkbox-white-active-svg'
	| 'icon-checkbox-white-default-svg'
	| 'icon-checkbox-white-hover-svg'
	| 'icon-country-global-svg'
	| 'icon-country-image-svg'
	| 'icon-country-location-svg'
	| 'icon-hashtag-black-svg'
	| 'icon-hashtag-white-svg'
	| 'icon-mark-auth-svg'
	| 'icon-mark-biz-svg'
	| 'icon-my-left-svg'
	| 'icon-my-right-svg'
	| 'icon-navigation-chevron-black-down-svg'
	| 'icon-navigation-chevron-black-left-lg-svg'
	| 'icon-navigation-chevron-black-left-sm-svg'
	| 'icon-navigation-chevron-black-right-lg-svg'
	| 'icon-navigation-chevron-black-right-sm-svg'
	| 'icon-navigation-chevron-black-up-lg-svg'
	| 'icon-navigation-chevron-black-up-sm-svg'
	| 'icon-navigation-chevron-cash-down-svg'
	| 'icon-navigation-chevron-casual-down-svg'
	| 'icon-navigation-chevron-gray-left-svg'
	| 'icon-navigation-chevron-gray-right-svg'
	| 'icon-navigation-chevron-purple-left-lg-svg'
	| 'icon-navigation-chevron-purple-left-sm-svg'
	| 'icon-navigation-chevron-purple-right-lg-svg'
	| 'icon-navigation-chevron-purple-right-sm-svg'
	| 'icon-navigation-chevron-white-down-svg'
	| 'icon-navigation-chevron-white-left-lg-svg'
	| 'icon-navigation-chevron-white-left-sm-svg'
	| 'icon-navigation-chevron-white-right-lg-svg'
	| 'icon-navigation-chevron-white-right-sm-svg'
	| 'icon-navigation-chevron-white-up-svg'
	| 'icon-navigation-close-black-small-svg'
	| 'icon-navigation-close-black-svg'
	| 'icon-navigation-close-white-small-svg'
	| 'icon-navigation-close-white-svg'
	| 'icon-personnel-icon-personnel-png'
	| 'icon-personnel-icon-personnel-svg'
	| 'icon-play-play-svg'
	| 'icon-radio-active-svg'
	| 'icon-radio-enabled-svg'
	| 'icon-scale-default-svg'
	| 'icon-scale-pressed-svg'
	| 'icon-score-a-png'
	| 'icon-score-b-png'
	| 'icon-score-c-png'
	| 'icon-score-d-png'
	| 'icon-score-f-png'
	| 'icon-score-s-plus-png'
	| 'icon-score-s-png'
	| 'icon-search-gray-svg'
	| 'icon-search-purple-svg'
	| 'icon-search-white-svg'
	| 'icon-sign-clear-svg'
	| 'icon-sign-colon-svg'
	| 'icon-sign-dance-list-svg'
	| 'icon-sign-file-svg'
	| 'icon-sign-plus-svg'
	| 'icon-sign-red-dot-svg'
	| 'icon-sign-upload-purple-svg'
	| 'icon-sign-upload-red-svg'
	| 'icon-sign-upload-white-svg'
	| 'icon-sign-view-count-svg'
	| 'icon-sns-apple-svg'
	| 'icon-sns-email-svg'
	| 'icon-sns-google-svg'
	| 'icon-social-apple-svg'
	| 'icon-social-block-svg'
	| 'icon-social-boost-active-svg'
	| 'icon-social-boost-default-svg'
	| 'icon-social-boost-hide-svg'
	| 'icon-social-boost-unhide-svg'
	| 'icon-social-cash-svg'
	| 'icon-social-casual-svg'
	| 'icon-social-comment-active-svg'
	| 'icon-social-comment-default-svg'
	| 'icon-social-comment-hide-svg'
	| 'icon-social-comment-unhide-svg'
	| 'icon-social-download-svg'
	| 'icon-social-email-svg'
	| 'icon-social-facebook-svg'
	| 'icon-social-follow-follow-svg'
	| 'icon-social-follow-unfollow-svg'
	| 'icon-social-google-svg'
	| 'icon-social-hide-svg'
	| 'icon-social-like-active-svg'
	| 'icon-social-like-default-svg'
	| 'icon-social-like-hide-svg'
	| 'icon-social-like-unhide-svg'
	| 'icon-social-meatball-svg'
	| 'icon-social-modify-svg'
	| 'icon-social-profile-contents-profile-add-svg'
	| 'icon-social-settings-upload-svg'
	| 'icon-social-share-svg'
	| 'icon-social-thumbtack-black-off-svg'
	| 'icon-social-thumbtack-black-on-svg'
	| 'icon-social-thumbtack-white-svg'
	| 'icon-social-unhide-svg'
	| 'icon-social-view-black-hide-svg'
	| 'icon-social-view-black-unhide-svg'
	| 'icon-social-view-purple-hide-svg'
	| 'icon-social-view-purple-unhide-svg'
	| 'icon-social-view-white-hide-svg'
	| 'icon-social-view-white-unhide-svg'
	| 'icon-sticker-1st-png'
	| 'icon-sticker-2nd-png'
	| 'icon-sticker-3rd-png'
	| 'icon-sticker-4th-png'
	| 'icon-sticker-account-svg'
	| 'icon-sticker-block-red-svg'
	| 'icon-sticker-business-crown-png'
	| 'icon-sticker-business-svg'
	| 'icon-sticker-certify-svg'
	| 'icon-sticker-colon-disabled-svg'
	| 'icon-sticker-colon-enabled-svg'
	| 'icon-sticker-connect-svg'
	| 'icon-sticker-connection-svg'
	| 'icon-sticker-delete-active-svg'
	| 'icon-sticker-error-rectangle-svg'
	| 'icon-sticker-error-round-svg'
	| 'icon-sticker-fail-svg'
	| 'icon-sticker-global-png'
	| 'icon-sticker-korea-png'
	| 'icon-sticker-logo-loading-svg'
	| 'icon-sticker-must-svg'
	| 'icon-sticker-report-svg'
	| 'icon-sticker-select-png'
	| 'icon-sticker-song-gray-svg'
	| 'icon-sticker-song-purple-svg'
	| 'icon-sticker-success-svg'
	| 'icon-sticker-timer-black-svg'
	| 'icon-sticker-timer-red-svg'
	| 'icon-tab-application-active-svg'
	| 'icon-tab-application-default-svg'
	| 'icon-tab-application-hover-svg'
	| 'icon-tab-biz-account-active-svg'
	| 'icon-tab-biz-account-default-svg'
	| 'icon-tab-biz-account-hover-svg'
	| 'icon-tab-create-active-svg'
	| 'icon-tab-create-default-svg'
	| 'icon-tab-create-hover-svg'
	| 'icon-tab-manage-active-svg'
	| 'icon-tab-manage-default-svg'
	| 'icon-tab-manage-hover-svg'
	| 'icon-tracking-default-svg'
	| 'icon-tracking-pressed-svg'
	| 'payment-payment-boost-png'
	| 'payment-payment-diamond-png'
	| 'payment-payment-dollar-png'
	| 'payment-payment-energy-png'
	| 'payment-payment-gold-png'
	| 'payment-prize-left-png'
	| 'payment-prize-right-png'
	| 'payment-symbol-ca-png'
	| 'payment-symbol-en-png'
	| 'payment-symbol-eu-png'
	| 'payment-symbol-gb-png'
	| 'payment-symbol-hk-png'
	| 'payment-symbol-id-png'
	| 'payment-symbol-in-png'
	| 'payment-symbol-ja-png'
	| 'payment-symbol-ko-png'
	| 'payment-symbol-ms-png'
	| 'payment-symbol-ph-png'
	| 'payment-symbol-th-png'
	| 'payment-symbol-vi-png'
	| 'tournament-bracket-title-3rd-dimmed-png'
	| 'tournament-bracket-title-3rd-png'
	| 'tournament-bracket-title-finals-png'
	| 'tournament-bracket-title-semi-png'
	| 'tournament-bracket-title-title-png'
	| 'tournament-bracket-vs-finals-png'
	| 'tournament-bracket-vs-frame-png'
	| 'tournament-icon-bracket-svg'
	| 'tournament-icon-download-png'
	| 'tournament-icon-event-black-svg'
	| 'tournament-icon-event-white-svg'
	| 'tournament-icon-invite-black-svg'
	| 'tournament-icon-invite-white-svg'
	| 'tournament-icon-list-svg'
	| 'tournament-icon-play-circle-png'
	| 'tournament-icon-private-png'
	| 'tournament-icon-public-png'
	| 'tournament-icon-qualify-black-svg'
	| 'tournament-icon-qualify-white-svg'
	| 'tournament-icon-scaleup-png'
	| 'tournament-icon-see-less-svg'
	| 'tournament-icon-see-more-svg'
	| 'tournament-icon-series-black-svg'
	| 'tournament-icon-series-white-svg'
	| 'tournament-images-backgroundColorTooltip-png'
	| 'tournament-images-songListTooltip-png'
	| 'tournament-medal-1st-png'
	| 'tournament-medal-2nd-png'
	| 'tournament-medal-3rd-png'
	| 'tournament-onAir-off-svg'
	| 'tournament-onAir-on-svg'
	| 'tournament-participate-off-svg'
	| 'tournament-participate-on-svg'
	| 'tournament-round-1024-active-png'
	| 'tournament-round-1024-disabled-png'
	| 'tournament-round-1024-enabled-png'
	| 'tournament-round-128-active-png'
	| 'tournament-round-128-disabled-png'
	| 'tournament-round-128-enabled-png'
	| 'tournament-round-16-active-png'
	| 'tournament-round-16-disabled-png'
	| 'tournament-round-16-enabled-png'
	| 'tournament-round-256-active-png'
	| 'tournament-round-256-disabled-png'
	| 'tournament-round-256-enabled-png'
	| 'tournament-round-32-active-png'
	| 'tournament-round-32-disabled-png'
	| 'tournament-round-32-enabled-png'
	| 'tournament-round-512-active-png'
	| 'tournament-round-512-disabled-png'
	| 'tournament-round-512-enabled-png'
	| 'tournament-round-64-active-png'
	| 'tournament-round-64-disabled-png'
	| 'tournament-round-64-enabled-png'
	| 'tournament-round-8-active-png'
	| 'tournament-round-8-disabled-png'
	| 'tournament-round-8-enabled-png'
	| 'tournament-round-finals-active-png'
	| 'tournament-round-finals-disabled-png'
	| 'tournament-round-finals-enabled-png'
	| 'tournament-round-semi-active-png'
	| 'tournament-round-semi-disabled-png'
	| 'tournament-round-semi-enabled-png'
	| 'tournament-status-basic-finished-png'
	| 'tournament-status-basic-live-png'
	| 'tournament-status-basic-open-png'
	| 'tournament-status-basic-setup-png'
	| 'tournament-status-basic-upcoming-png'
	| 'tournament-status-bubble-finished-png'
	| 'tournament-status-bubble-live-png'
	| 'tournament-status-bubble-prematch-png'
	| 'tournament-status-bubble-qualifier-png'
	| 'tournament-status-bubble-register-png'
	| 'tournament-status-bubble-selecting-png'
	| 'tournament-status-bubble-upcoming-png'
	| 'tournament-status-text-colored-live-png'
	| 'tournament-status-text-colored-prematch-png'
	| 'tournament-status-text-colored-qualifier-png'
	| 'tournament-status-text-colored-register-png'
	| 'tournament-status-text-colored-selecting-png'
	| 'tournament-status-text-colored-upcoming-png'
	| 'tournament-status-text-default-finished-png'
	| 'tournament-status-text-default-live-png'
	| 'tournament-status-text-default-prematch-png'
	| 'tournament-status-text-default-qualifier-png'
	| 'tournament-status-text-default-register-png'
	| 'tournament-status-text-default-selecting-png'
	| 'tournament-tab-biz-gray-svg'
	| 'tournament-tab-biz-purple-svg'
	| 'tournament-tab-feed-gray-svg'
	| 'tournament-tab-feed-purple-svg'
	| 'tournament-tab-home-gray-svg'
	| 'tournament-tab-home-purple-svg'
	| 'tournament-tab-my-gray-svg'
	| 'tournament-tab-my-purple-svg'
	| 'tournament-tab-ranking-gray-svg'
	| 'tournament-tab-ranking-purple-svg'
	| 'tournament-tab-trophy-gray-svg'
	| 'tournament-tab-trophy-purple-svg'
	| 'tournament-tab-trophy-white-svg'
	| 'tournament-tournament-basic-3rd-place-png'
	| 'tournament-tournament-basic-3rd-png'
	| 'tournament-tournament-basic-3rd-title-png'
	| 'tournament-tournament-basic-3rd-win-png'
	| 'tournament-tournament-basic-3rd-winner-png'
	| 'tournament-tournament-basic-early-png'
	| 'tournament-tournament-basic-early-title-png'
	| 'tournament-tournament-basic-early-win-png'
	| 'tournament-tournament-basic-early-winner-png'
	| 'tournament-tournament-basic-eighth-png'
	| 'tournament-tournament-basic-eighth-title-png'
	| 'tournament-tournament-basic-eighth-win-png'
	| 'tournament-tournament-basic-eighth-winner-png'
	| 'tournament-tournament-basic-finals-png'
	| 'tournament-tournament-basic-finals-title-png'
	| 'tournament-tournament-basic-finals-win-png'
	| 'tournament-tournament-basic-finals-winner-png'
	| 'tournament-tournament-basic-first-png'
	| 'tournament-tournament-basic-first-title-png'
	| 'tournament-tournament-basic-first-win-png'
	| 'tournament-tournament-basic-first-winner-png'
	| 'tournament-tournament-basic-late-png'
	| 'tournament-tournament-basic-late-title-png'
	| 'tournament-tournament-basic-late-win-png'
	| 'tournament-tournament-basic-late-winner-png'
	| 'tournament-tournament-basic-middle-png'
	| 'tournament-tournament-basic-middle-title-png'
	| 'tournament-tournament-basic-middle-win-png'
	| 'tournament-tournament-basic-middle-winner-png'
	| 'tournament-tournament-basic-pre-semi-png'
	| 'tournament-tournament-basic-pre-semi-title-png'
	| 'tournament-tournament-basic-pre-semi-win-png'
	| 'tournament-tournament-basic-pre-semi-winner-png'
	| 'tournament-tournament-basic-preliminary-png'
	| 'tournament-tournament-basic-preliminary-title-png'
	| 'tournament-tournament-basic-preliminary-win-png'
	| 'tournament-tournament-basic-preliminary-winner-png'
	| 'tournament-tournament-basic-quarter-png'
	| 'tournament-tournament-basic-quarter-title-png'
	| 'tournament-tournament-basic-quarter-win-png'
	| 'tournament-tournament-basic-quarter-winner-png'
	| 'tournament-tournament-basic-semi-png'
	| 'tournament-tournament-basic-semi-title-png'
	| 'tournament-tournament-basic-semi-win-png'
	| 'tournament-tournament-basic-semi-winner-png'
	| 'tournament-tournament-basic-title-match-finals-png'
	| 'tournament-tournament-rank-1st-png'
	| 'tournament-tournament-rank-2nd-png'
	| 'tournament-tournament-rank-3rd-png'
	| 'tournament-tournament-rank-4th-png'
	| 'tournament-tournament-rank-finished-1st-png'
	| 'tournament-tournament-rank-finished-2nd-png'
	| 'tournament-tournament-rank-finished-3rd-png'
	| 'tournament-tournament-rank-finished-4th-png'
	| 'tournament-tournament-rank-finished-modal-1st-png'
	| 'tournament-tournament-rank-finished-modal-2nd-png'
	| 'tournament-tournament-rank-finished-modal-3rd-png'
	| 'tournament-tournament-rank-finished-modal-4th-png'
	| 'tournament-video-1st-png'
	| 'tournament-video-2nd-png'
	| 'tournament-video-3rd-png'
	| 'tournament-vs-3rd-png'
	| 'tournament-vs-finals-png'
	| 'tournament-vs-vs-png'
	| 'tournament-winner-3rd-png'
	| 'tournament-winner-finals-png'
	| 'tournament-winner-r1024-png'
	| 'tournament-winner-r128-png'
	| 'tournament-winner-r16-png'
	| 'tournament-winner-r256-png'
	| 'tournament-winner-r32-png'
	| 'tournament-winner-r512-png'
	| 'tournament-winner-r64-png'
	| 'tournament-winner-r8-png'
	| 'tournament-winner-semi-png';

/**
 * Asset 정보 인터페이스
 */
export interface AssetInfo {
	name: string;
	filename: string;
	path: string;
	extension: string;
	type: 'icon' | 'image' | 'asset';
	category: string;
	assetDir: string;
}

/**
 * Size 객체 타입
 */
export type SizeObject =
	| { width: number; height?: number }
	| { width?: number; height: number }
	| { width: number; height: number };

/**
 * Asset Size 타입
 */
export type AssetSize = SizeType | number | SizeObject;

/**
 * Asset Color 타입
 */
export type AssetColor = ColorType | string;

/**
 * Asset 컴포넌트 Props (원본 discriminated union)
 */
export type AssetProps =
	| {
			type: 'icon';
			name: AssetName;
			src?: never;
			size?: AssetSize;
			color?: AssetColor;
			className?: string;
			style?: React.CSSProperties;
			'aria-label'?: string;
			alt?: string;
			fallback?: React.ReactNode;
			ratio?: number;
			decorative?: boolean;
	  }
	| {
			type: 'url';
			name?: never;
			src: string;
			size?: AssetSize;
			color?: AssetColor;
			className?: string;
			style?: React.CSSProperties;
			'aria-label'?: string;
			alt?: string;
			fallback?: React.ReactNode;
			ratio?: number;
			decorative?: boolean;
	  };

/**
 * Size 타입
 */
export type SizeType = 'lg' | 'md' | 'sm' | 'xl' | 'xs';

/**
 * Size 매핑
 */
export const sizeMap: Record<SizeType, number> = {
	xs: 16,
	sm: 20,
	md: 24,
	lg: 32,
	xl: 48,
};

/**
 * Color 타입
 */
export type ColorType = 'black' | 'gray' | 'green' | 'pink' | 'primary' | 'purple' | 'red' | 'secondary' | 'white';

/**
 * Color 매핑
 */
export const colorMap: Record<ColorType, string> = {
	primary: 'var(--color-primary)',
	secondary: 'var(--color-secondary)',
	gray: 'var(--color-gray)',
	white: '#FDFDFE',
	black: '#1A1A20',
	purple: '#6B60FA',
	pink: '#FF5E98',
	red: '#FF005C',
	green: '#2AE289',
};

/**
 * Asset 경로 매핑
 * Asset 이름으로 파일 정보에 접근할 수 있습니다
 */
export const assetPathMap: Record<AssetName, AssetInfo> = {
	'auth-action-checkbox-active-svg': {
		name: 'auth-action-checkbox-active',
		filename: 'auth-action-checkbox-active.svg',
		path: 'action/checkbox/auth-action-checkbox-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-checkbox-default-black-svg': {
		name: 'auth-action-checkbox-default-black',
		filename: 'auth-action-checkbox-default-black.svg',
		path: 'action/checkbox/auth-action-checkbox-default-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-checkbox-default-white-svg': {
		name: 'auth-action-checkbox-default-white',
		filename: 'auth-action-checkbox-default-white.svg',
		path: 'action/checkbox/auth-action-checkbox-default-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-clear-gray-svg': {
		name: 'auth-action-clear-gray',
		filename: 'auth-action-clear-gray.svg',
		path: 'action/clear/auth-action-clear-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-clear-purple-active-svg': {
		name: 'auth-action-clear-purple-active',
		filename: 'auth-action-clear-purple-active.svg',
		path: 'action/clear/auth-action-clear-purple-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-clear-purple-default-svg': {
		name: 'auth-action-clear-purple-default',
		filename: 'auth-action-clear-purple-default.svg',
		path: 'action/clear/auth-action-clear-purple-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-clear-red-svg': {
		name: 'auth-action-clear-red',
		filename: 'auth-action-clear-red.svg',
		path: 'action/clear/auth-action-clear-red.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-code-active-svg': {
		name: 'auth-action-code-active',
		filename: 'auth-action-code-active.svg',
		path: 'action/code/auth-action-code-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-code-default-svg': {
		name: 'auth-action-code-default',
		filename: 'auth-action-code-default.svg',
		path: 'action/code/auth-action-code-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-confirm-password-active-svg': {
		name: 'auth-action-confirm-password-active',
		filename: 'auth-action-confirm-password-active.svg',
		path: 'action/confirm-password/auth-action-confirm-password-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-confirm-password-default-svg': {
		name: 'auth-action-confirm-password-default',
		filename: 'auth-action-confirm-password-default.svg',
		path: 'action/confirm-password/auth-action-confirm-password-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-email-active-svg': {
		name: 'auth-action-email-active',
		filename: 'auth-action-email-active.svg',
		path: 'action/email/auth-action-email-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-email-default-svg': {
		name: 'auth-action-email-default',
		filename: 'auth-action-email-default.svg',
		path: 'action/email/auth-action-email-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-password-active-svg': {
		name: 'auth-action-password-active',
		filename: 'auth-action-password-active.svg',
		path: 'action/password/auth-action-password-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-action-password-default-svg': {
		name: 'auth-action-password-default',
		filename: 'auth-action-password-default.svg',
		path: 'action/password/auth-action-password-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'auth',
	},
	'auth-chevron-right-svg': {
		name: 'auth-chevron-right',
		filename: 'auth-chevron-right.svg',
		path: 'chevron/auth-chevron-right.svg',
		extension: 'svg',
		type: 'icon',
		category: 'chevron',
		assetDir: 'auth',
	},
	'auth-icon-arcade-logo-with-speaker-png': {
		name: 'auth-icon-arcade-logo-with-speaker',
		filename: 'auth-icon-arcade-logo-with-speaker.png',
		path: 'icon/auth-icon-arcade-logo-with-speaker.png',
		extension: 'png',
		type: 'image',
		category: 'icon',
		assetDir: 'auth',
	},
	'auth-icon-arcade-logo-png': {
		name: 'auth-icon-arcade-logo',
		filename: 'auth-icon-arcade-logo.png',
		path: 'icon/auth-icon-arcade-logo.png',
		extension: 'png',
		type: 'image',
		category: 'icon',
		assetDir: 'auth',
	},
	'auth-icon-globe-svg': {
		name: 'auth-icon-globe',
		filename: 'auth-icon-globe.svg',
		path: 'icon/auth-icon-globe.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'auth',
	},
	'auth-icon-stepin-logo-png': {
		name: 'auth-icon-stepin-logo',
		filename: 'auth-icon-stepin-logo.png',
		path: 'icon/auth-icon-stepin-logo.png',
		extension: 'png',
		type: 'image',
		category: 'icon',
		assetDir: 'auth',
	},
	'icon-3D-energy-1-png': {
		name: 'icon-3D-energy-1',
		filename: 'icon-3D-energy-1.png',
		path: '3D/icon-3D-energy-1.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-energy-2-png': {
		name: 'icon-3D-energy-2',
		filename: 'icon-3D-energy-2.png',
		path: '3D/icon-3D-energy-2.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-energy-3-png': {
		name: 'icon-3D-energy-3',
		filename: 'icon-3D-energy-3.png',
		path: '3D/icon-3D-energy-3.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-energy-4-png': {
		name: 'icon-3D-energy-4',
		filename: 'icon-3D-energy-4.png',
		path: '3D/icon-3D-energy-4.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-energy-5-png': {
		name: 'icon-3D-energy-5',
		filename: 'icon-3D-energy-5.png',
		path: '3D/icon-3D-energy-5.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-energy-6-png': {
		name: 'icon-3D-energy-6',
		filename: 'icon-3D-energy-6.png',
		path: '3D/icon-3D-energy-6.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-banner-png': {
		name: 'icon-3D-image-banner',
		filename: 'icon-3D-image-banner.png',
		path: '3D/icon-3D-image-banner.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-cash-png': {
		name: 'icon-3D-image-cash',
		filename: 'icon-3D-image-cash.png',
		path: '3D/icon-3D-image-cash.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-date-png': {
		name: 'icon-3D-image-date',
		filename: 'icon-3D-image-date.png',
		path: '3D/icon-3D-image-date.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-diamond-png': {
		name: 'icon-3D-image-diamond',
		filename: 'icon-3D-image-diamond.png',
		path: '3D/icon-3D-image-diamond.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-global-png': {
		name: 'icon-3D-image-global',
		filename: 'icon-3D-image-global.png',
		path: '3D/icon-3D-image-global.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-lock-png': {
		name: 'icon-3D-image-lock',
		filename: 'icon-3D-image-lock.png',
		path: '3D/icon-3D-image-lock.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-notice-png': {
		name: 'icon-3D-image-notice',
		filename: 'icon-3D-image-notice.png',
		path: '3D/icon-3D-image-notice.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-poster-png': {
		name: 'icon-3D-image-poster',
		filename: 'icon-3D-image-poster.png',
		path: '3D/icon-3D-image-poster.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-song-list-png': {
		name: 'icon-3D-image-song-list',
		filename: 'icon-3D-image-song-list.png',
		path: '3D/icon-3D-image-song-list.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-song-png': {
		name: 'icon-3D-image-song',
		filename: 'icon-3D-image-song.png',
		path: '3D/icon-3D-image-song.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-text-png': {
		name: 'icon-3D-image-text',
		filename: 'icon-3D-image-text.png',
		path: '3D/icon-3D-image-text.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-3D-image-unlock-png': {
		name: 'icon-3D-image-unlock',
		filename: 'icon-3D-image-unlock.png',
		path: '3D/icon-3D-image-unlock.png',
		extension: 'png',
		type: 'image',
		category: '3D',
		assetDir: 'icon',
	},
	'icon-GNB-announcement-svg': {
		name: 'icon-GNB-announcement',
		filename: 'icon-GNB-announcement.svg',
		path: 'GNB/icon-GNB-announcement.svg',
		extension: 'svg',
		type: 'icon',
		category: 'GNB',
		assetDir: 'icon',
	},
	'icon-GNB-gnb-svg': {
		name: 'icon-GNB-gnb',
		filename: 'icon-GNB-gnb.svg',
		path: 'GNB/icon-GNB-gnb.svg',
		extension: 'svg',
		type: 'icon',
		category: 'GNB',
		assetDir: 'icon',
	},
	'icon-GNB-inbox-svg': {
		name: 'icon-GNB-inbox',
		filename: 'icon-GNB-inbox.svg',
		path: 'GNB/icon-GNB-inbox.svg',
		extension: 'svg',
		type: 'icon',
		category: 'GNB',
		assetDir: 'icon',
	},
	'icon-GNB-meatball-svg': {
		name: 'icon-GNB-meatball',
		filename: 'icon-GNB-meatball.svg',
		path: 'GNB/icon-GNB-meatball.svg',
		extension: 'svg',
		type: 'icon',
		category: 'GNB',
		assetDir: 'icon',
	},
	'icon-GNB-mission-svg': {
		name: 'icon-GNB-mission',
		filename: 'icon-GNB-mission.svg',
		path: 'GNB/icon-GNB-mission.svg',
		extension: 'svg',
		type: 'icon',
		category: 'GNB',
		assetDir: 'icon',
	},
	'icon-GNB-notice-svg': {
		name: 'icon-GNB-notice',
		filename: 'icon-GNB-notice.svg',
		path: 'GNB/icon-GNB-notice.svg',
		extension: 'svg',
		type: 'icon',
		category: 'GNB',
		assetDir: 'icon',
	},
	'icon-GNB-setting-svg': {
		name: 'icon-GNB-setting',
		filename: 'icon-GNB-setting.svg',
		path: 'GNB/icon-GNB-setting.svg',
		extension: 'svg',
		type: 'icon',
		category: 'GNB',
		assetDir: 'icon',
	},
	'icon-action-account-invite-svg': {
		name: 'icon-action-account-invite',
		filename: 'icon-action-account-invite.svg',
		path: 'action/icon-action-account-invite.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-account-withdrawal-svg': {
		name: 'icon-action-account-withdrawal',
		filename: 'icon-action-account-withdrawal.svg',
		path: 'action/icon-action-account-withdrawal.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-attendance-svg': {
		name: 'icon-action-attendance',
		filename: 'icon-action-attendance.svg',
		path: 'action/icon-action-attendance.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-bookmark-purple-active-svg': {
		name: 'icon-action-bookmark-purple-active',
		filename: 'icon-action-bookmark-purple-active.svg',
		path: 'action/icon-action-bookmark-purple-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-bookmark-purple-default-svg': {
		name: 'icon-action-bookmark-purple-default',
		filename: 'icon-action-bookmark-purple-default.svg',
		path: 'action/icon-action-bookmark-purple-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-bookmark-white-active-svg': {
		name: 'icon-action-bookmark-white-active',
		filename: 'icon-action-bookmark-white-active.svg',
		path: 'action/icon-action-bookmark-white-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-bookmark-white-default-svg': {
		name: 'icon-action-bookmark-white-default',
		filename: 'icon-action-bookmark-white-default.svg',
		path: 'action/icon-action-bookmark-white-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-box-disabled-svg': {
		name: 'icon-action-box-disabled',
		filename: 'icon-action-box-disabled.svg',
		path: 'action/icon-action-box-disabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-box-enabled-svg': {
		name: 'icon-action-box-enabled',
		filename: 'icon-action-box-enabled.svg',
		path: 'action/icon-action-box-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-business-svg': {
		name: 'icon-action-business',
		filename: 'icon-action-business.svg',
		path: 'action/icon-action-business.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-change-biz-enabled-svg': {
		name: 'icon-action-change-biz-enabled',
		filename: 'icon-action-change-biz-enabled.svg',
		path: 'action/icon-action-change-biz-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-change-biz-hover-svg': {
		name: 'icon-action-change-biz-hover',
		filename: 'icon-action-change-biz-hover.svg',
		path: 'action/icon-action-change-biz-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-change-biz-pressed-svg': {
		name: 'icon-action-change-biz-pressed',
		filename: 'icon-action-change-biz-pressed.svg',
		path: 'action/icon-action-change-biz-pressed.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-change-default-enabled-svg': {
		name: 'icon-action-change-default-enabled',
		filename: 'icon-action-change-default-enabled.svg',
		path: 'action/icon-action-change-default-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-change-default-hover-svg': {
		name: 'icon-action-change-default-hover',
		filename: 'icon-action-change-default-hover.svg',
		path: 'action/icon-action-change-default-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-change-default-pressed-svg': {
		name: 'icon-action-change-default-pressed',
		filename: 'icon-action-change-default-pressed.svg',
		path: 'action/icon-action-change-default-pressed.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-check-black-active-svg': {
		name: 'icon-action-check-black-active',
		filename: 'icon-action-check-black-active.svg',
		path: 'action/icon-action-check-black-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-check-black-default-svg': {
		name: 'icon-action-check-black-default',
		filename: 'icon-action-check-black-default.svg',
		path: 'action/icon-action-check-black-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-check-gray-svg': {
		name: 'icon-action-check-gray',
		filename: 'icon-action-check-gray.svg',
		path: 'action/icon-action-check-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-checkbox-l-active-svg': {
		name: 'icon-action-checkbox-l-active',
		filename: 'icon-action-checkbox-l-active.svg',
		path: 'action/icon-action-checkbox-l-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-checkbox-l-default-svg': {
		name: 'icon-action-checkbox-l-default',
		filename: 'icon-action-checkbox-l-default.svg',
		path: 'action/icon-action-checkbox-l-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-checkbox-s-active-svg': {
		name: 'icon-action-checkbox-s-active',
		filename: 'icon-action-checkbox-s-active.svg',
		path: 'action/icon-action-checkbox-s-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-checkbox-s-default-svg': {
		name: 'icon-action-checkbox-s-default',
		filename: 'icon-action-checkbox-s-default.svg',
		path: 'action/icon-action-checkbox-s-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-chevron-circle-white-left-disabled-svg': {
		name: 'icon-action-chevron-circle-white-left-disabled',
		filename: 'icon-action-chevron-circle-white-left-disabled.svg',
		path: 'action/icon-action-chevron-circle-white-left-disabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-chevron-circle-white-left-enabled-svg': {
		name: 'icon-action-chevron-circle-white-left-enabled',
		filename: 'icon-action-chevron-circle-white-left-enabled.svg',
		path: 'action/icon-action-chevron-circle-white-left-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-chevron-circle-white-left-svg': {
		name: 'icon-action-chevron-circle-white-left',
		filename: 'icon-action-chevron-circle-white-left.svg',
		path: 'action/icon-action-chevron-circle-white-left.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-chevron-circle-white-right-disabled-svg': {
		name: 'icon-action-chevron-circle-white-right-disabled',
		filename: 'icon-action-chevron-circle-white-right-disabled.svg',
		path: 'action/icon-action-chevron-circle-white-right-disabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-chevron-circle-white-right-enabled-svg': {
		name: 'icon-action-chevron-circle-white-right-enabled',
		filename: 'icon-action-chevron-circle-white-right-enabled.svg',
		path: 'action/icon-action-chevron-circle-white-right-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-chevron-circle-white-right-svg': {
		name: 'icon-action-chevron-circle-white-right',
		filename: 'icon-action-chevron-circle-white-right.svg',
		path: 'action/icon-action-chevron-circle-white-right.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-chevron-white-left-svg': {
		name: 'icon-action-chevron-white-left',
		filename: 'icon-action-chevron-white-left.svg',
		path: 'action/icon-action-chevron-white-left.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-chevron-white-right-svg': {
		name: 'icon-action-chevron-white-right',
		filename: 'icon-action-chevron-white-right.svg',
		path: 'action/icon-action-chevron-white-right.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-circle-active-svg': {
		name: 'icon-action-circle-active',
		filename: 'icon-action-circle-active.svg',
		path: 'action/icon-action-circle-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-circle-default-svg': {
		name: 'icon-action-circle-default',
		filename: 'icon-action-circle-default.svg',
		path: 'action/icon-action-circle-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-circle-l-active-svg': {
		name: 'icon-action-circle-l-active',
		filename: 'icon-action-circle-l-active.svg',
		path: 'action/icon-action-circle-l-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-circle-l-default-svg': {
		name: 'icon-action-circle-l-default',
		filename: 'icon-action-circle-l-default.svg',
		path: 'action/icon-action-circle-l-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-circle-s-active-svg': {
		name: 'icon-action-circle-s-active',
		filename: 'icon-action-circle-s-active.svg',
		path: 'action/icon-action-circle-s-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-circle-s-default-svg': {
		name: 'icon-action-circle-s-default',
		filename: 'icon-action-circle-s-default.svg',
		path: 'action/icon-action-circle-s-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-circle-svg': {
		name: 'icon-action-circle',
		filename: 'icon-action-circle.svg',
		path: 'action/icon-action-circle.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-clear-gray-svg': {
		name: 'icon-action-clear-gray',
		filename: 'icon-action-clear-gray.svg',
		path: 'action/icon-action-clear-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-clear-purple-svg': {
		name: 'icon-action-clear-purple',
		filename: 'icon-action-clear-purple.svg',
		path: 'action/icon-action-clear-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-clear-white-svg': {
		name: 'icon-action-clear-white',
		filename: 'icon-action-clear-white.svg',
		path: 'action/icon-action-clear-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-code-active-svg': {
		name: 'icon-action-code-active',
		filename: 'icon-action-code-active.svg',
		path: 'action/icon-action-code-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-code-default-svg': {
		name: 'icon-action-code-default',
		filename: 'icon-action-code-default.svg',
		path: 'action/icon-action-code-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-delete-active-svg': {
		name: 'icon-action-delete-active',
		filename: 'icon-action-delete-active.svg',
		path: 'action/icon-action-delete-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-delete-default-svg': {
		name: 'icon-action-delete-default',
		filename: 'icon-action-delete-default.svg',
		path: 'action/icon-action-delete-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-dropdown-black-down-svg': {
		name: 'icon-action-dropdown-black-down',
		filename: 'icon-action-dropdown-black-down.svg',
		path: 'action/icon-action-dropdown-black-down.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-dropdown-black-up-svg': {
		name: 'icon-action-dropdown-black-up',
		filename: 'icon-action-dropdown-black-up.svg',
		path: 'action/icon-action-dropdown-black-up.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-edit-pencil-svg': {
		name: 'icon-action-edit-pencil',
		filename: 'icon-action-edit-pencil.svg',
		path: 'action/icon-action-edit-pencil.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-edit-stick-svg': {
		name: 'icon-action-edit-stick',
		filename: 'icon-action-edit-stick.svg',
		path: 'action/icon-action-edit-stick.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-email-active-svg': {
		name: 'icon-action-email-active',
		filename: 'icon-action-email-active.svg',
		path: 'action/icon-action-email-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-email-default-svg': {
		name: 'icon-action-email-default',
		filename: 'icon-action-email-default.svg',
		path: 'action/icon-action-email-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-exclude-black-svg': {
		name: 'icon-action-exclude-black',
		filename: 'icon-action-exclude-black.svg',
		path: 'action/icon-action-exclude-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-exclude-white-svg': {
		name: 'icon-action-exclude-white',
		filename: 'icon-action-exclude-white.svg',
		path: 'action/icon-action-exclude-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-floating-chat-default-1-svg': {
		name: 'icon-action-floating-chat-default-1',
		filename: 'icon-action-floating-chat-default-1.svg',
		path: 'action/icon-action-floating-chat-default-1.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-floating-chat-default-svg': {
		name: 'icon-action-floating-chat-default',
		filename: 'icon-action-floating-chat-default.svg',
		path: 'action/icon-action-floating-chat-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-floating-chat-hover-svg': {
		name: 'icon-action-floating-chat-hover',
		filename: 'icon-action-floating-chat-hover.svg',
		path: 'action/icon-action-floating-chat-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-floating-chat-svg': {
		name: 'icon-action-floating-chat',
		filename: 'icon-action-floating-chat.svg',
		path: 'action/icon-action-floating-chat.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-gnb-svg': {
		name: 'icon-action-gnb',
		filename: 'icon-action-gnb.svg',
		path: 'action/icon-action-gnb.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-inbox-active-svg': {
		name: 'icon-action-inbox-active',
		filename: 'icon-action-inbox-active.svg',
		path: 'action/icon-action-inbox-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-inbox-default-svg': {
		name: 'icon-action-inbox-default',
		filename: 'icon-action-inbox-default.svg',
		path: 'action/icon-action-inbox-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-inbox-t-active-svg': {
		name: 'icon-action-inbox-t-active',
		filename: 'icon-action-inbox-t-active.svg',
		path: 'action/icon-action-inbox-t-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-inbox-t-default-svg': {
		name: 'icon-action-inbox-t-default',
		filename: 'icon-action-inbox-t-default.svg',
		path: 'action/icon-action-inbox-t-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-kebab-black-svg': {
		name: 'icon-action-kebab-black',
		filename: 'icon-action-kebab-black.svg',
		path: 'action/icon-action-kebab-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-kebab-white-svg': {
		name: 'icon-action-kebab-white',
		filename: 'icon-action-kebab-white.svg',
		path: 'action/icon-action-kebab-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-language-active-svg': {
		name: 'icon-action-language-active',
		filename: 'icon-action-language-active.svg',
		path: 'action/icon-action-language-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-language-default-svg': {
		name: 'icon-action-language-default',
		filename: 'icon-action-language-default.svg',
		path: 'action/icon-action-language-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-language-hover-svg': {
		name: 'icon-action-language-hover',
		filename: 'icon-action-language-hover.svg',
		path: 'action/icon-action-language-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-language-svg': {
		name: 'icon-action-language',
		filename: 'icon-action-language.svg',
		path: 'action/icon-action-language.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-logout-active-svg': {
		name: 'icon-action-logout-active',
		filename: 'icon-action-logout-active.svg',
		path: 'action/icon-action-logout-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-logout-default-svg': {
		name: 'icon-action-logout-default',
		filename: 'icon-action-logout-default.svg',
		path: 'action/icon-action-logout-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-logout-hover-svg': {
		name: 'icon-action-logout-hover',
		filename: 'icon-action-logout-hover.svg',
		path: 'action/icon-action-logout-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-meatball-black-svg': {
		name: 'icon-action-meatball-black',
		filename: 'icon-action-meatball-black.svg',
		path: 'action/icon-action-meatball-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-meatball-white-svg': {
		name: 'icon-action-meatball-white',
		filename: 'icon-action-meatball-white.svg',
		path: 'action/icon-action-meatball-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-meatballs-enabled-svg': {
		name: 'icon-action-meatballs-enabled',
		filename: 'icon-action-meatballs-enabled.svg',
		path: 'action/icon-action-meatballs-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-meatballs-hover-svg': {
		name: 'icon-action-meatballs-hover',
		filename: 'icon-action-meatballs-hover.svg',
		path: 'action/icon-action-meatballs-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-meatballs-pressed-svg': {
		name: 'icon-action-meatballs-pressed',
		filename: 'icon-action-meatballs-pressed.svg',
		path: 'action/icon-action-meatballs-pressed.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-member-in-svg': {
		name: 'icon-action-member-in',
		filename: 'icon-action-member-in.svg',
		path: 'action/icon-action-member-in.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-member-out-svg': {
		name: 'icon-action-member-out',
		filename: 'icon-action-member-out.svg',
		path: 'action/icon-action-member-out.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-notice-active-svg': {
		name: 'icon-action-notice-active',
		filename: 'icon-action-notice-active.svg',
		path: 'action/icon-action-notice-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-notice-default-svg': {
		name: 'icon-action-notice-default',
		filename: 'icon-action-notice-default.svg',
		path: 'action/icon-action-notice-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-password-active-svg': {
		name: 'icon-action-password-active',
		filename: 'icon-action-password-active.svg',
		path: 'action/icon-action-password-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-password-default-svg': {
		name: 'icon-action-password-default',
		filename: 'icon-action-password-default.svg',
		path: 'action/icon-action-password-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-pause-hover-svg': {
		name: 'icon-action-pause-hover',
		filename: 'icon-action-pause-hover.svg',
		path: 'action/icon-action-pause-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-pause-svg': {
		name: 'icon-action-pause',
		filename: 'icon-action-pause.svg',
		path: 'action/icon-action-pause.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-play-black-svg': {
		name: 'icon-action-play-black',
		filename: 'icon-action-play-black.svg',
		path: 'action/icon-action-play-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-play-hover-svg': {
		name: 'icon-action-play-hover',
		filename: 'icon-action-play-hover.svg',
		path: 'action/icon-action-play-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-play-svg': {
		name: 'icon-action-play',
		filename: 'icon-action-play.svg',
		path: 'action/icon-action-play.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-playicon-challenge-svg': {
		name: 'icon-action-playicon-challenge',
		filename: 'icon-action-playicon-challenge.svg',
		path: 'action/icon-action-playicon-challenge.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-playicon-practice-svg': {
		name: 'icon-action-playicon-practice',
		filename: 'icon-action-playicon-practice.svg',
		path: 'action/icon-action-playicon-practice.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-playicon-rpd-svg': {
		name: 'icon-action-playicon-rpd',
		filename: 'icon-action-playicon-rpd.svg',
		path: 'action/icon-action-playicon-rpd.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-practice-svg': {
		name: 'icon-action-practice',
		filename: 'icon-action-practice.svg',
		path: 'action/icon-action-practice.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-refresh-black-svg': {
		name: 'icon-action-refresh-black',
		filename: 'icon-action-refresh-black.svg',
		path: 'action/icon-action-refresh-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-refresh-white-svg': {
		name: 'icon-action-refresh-white',
		filename: 'icon-action-refresh-white.svg',
		path: 'action/icon-action-refresh-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-remove-black-svg': {
		name: 'icon-action-remove-black',
		filename: 'icon-action-remove-black.svg',
		path: 'action/icon-action-remove-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-remove-gray-svg': {
		name: 'icon-action-remove-gray',
		filename: 'icon-action-remove-gray.svg',
		path: 'action/icon-action-remove-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-remove-purple-svg': {
		name: 'icon-action-remove-purple',
		filename: 'icon-action-remove-purple.svg',
		path: 'action/icon-action-remove-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-remove-white-svg': {
		name: 'icon-action-remove-white',
		filename: 'icon-action-remove-white.svg',
		path: 'action/icon-action-remove-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-remove-svg': {
		name: 'icon-action-remove',
		filename: 'icon-action-remove.svg',
		path: 'action/icon-action-remove.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-report-active-svg': {
		name: 'icon-action-report-active',
		filename: 'icon-action-report-active.svg',
		path: 'action/icon-action-report-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-report-default-svg': {
		name: 'icon-action-report-default',
		filename: 'icon-action-report-default.svg',
		path: 'action/icon-action-report-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-report-hover-svg': {
		name: 'icon-action-report-hover',
		filename: 'icon-action-report-hover.svg',
		path: 'action/icon-action-report-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-rpd-svg': {
		name: 'icon-action-rpd',
		filename: 'icon-action-rpd.svg',
		path: 'action/icon-action-rpd.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-search-active-svg': {
		name: 'icon-action-search-active',
		filename: 'icon-action-search-active.svg',
		path: 'action/icon-action-search-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-search-challenge-svg': {
		name: 'icon-action-search-challenge',
		filename: 'icon-action-search-challenge.svg',
		path: 'action/icon-action-search-challenge.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-search-default-svg': {
		name: 'icon-action-search-default',
		filename: 'icon-action-search-default.svg',
		path: 'action/icon-action-search-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-search-purple-svg': {
		name: 'icon-action-search-purple',
		filename: 'icon-action-search-purple.svg',
		path: 'action/icon-action-search-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-search-white-svg': {
		name: 'icon-action-search-white',
		filename: 'icon-action-search-white.svg',
		path: 'action/icon-action-search-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-setting-active-svg': {
		name: 'icon-action-setting-active',
		filename: 'icon-action-setting-active.svg',
		path: 'action/icon-action-setting-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-setting-default-svg': {
		name: 'icon-action-setting-default',
		filename: 'icon-action-setting-default.svg',
		path: 'action/icon-action-setting-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-setting-enabled-svg': {
		name: 'icon-action-setting-enabled',
		filename: 'icon-action-setting-enabled.svg',
		path: 'action/icon-action-setting-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-setting-hover-svg': {
		name: 'icon-action-setting-hover',
		filename: 'icon-action-setting-hover.svg',
		path: 'action/icon-action-setting-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-setting-pressed-svg': {
		name: 'icon-action-setting-pressed',
		filename: 'icon-action-setting-pressed.svg',
		path: 'action/icon-action-setting-pressed.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-setting-white-svg': {
		name: 'icon-action-setting-white',
		filename: 'icon-action-setting-white.svg',
		path: 'action/icon-action-setting-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-settings-minus-svg': {
		name: 'icon-action-settings-minus',
		filename: 'icon-action-settings-minus.svg',
		path: 'action/icon-action-settings-minus.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-settings-plus-svg': {
		name: 'icon-action-settings-plus',
		filename: 'icon-action-settings-plus.svg',
		path: 'action/icon-action-settings-plus.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-skeleton-disabled-svg': {
		name: 'icon-action-skeleton-disabled',
		filename: 'icon-action-skeleton-disabled.svg',
		path: 'action/icon-action-skeleton-disabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-skeleton-enabled-svg': {
		name: 'icon-action-skeleton-enabled',
		filename: 'icon-action-skeleton-enabled.svg',
		path: 'action/icon-action-skeleton-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-speed-black-svg': {
		name: 'icon-action-speed-black',
		filename: 'icon-action-speed-black.svg',
		path: 'action/icon-action-speed-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-stop-black-svg': {
		name: 'icon-action-stop-black',
		filename: 'icon-action-stop-black.svg',
		path: 'action/icon-action-stop-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-suggest-biz-enabled-svg': {
		name: 'icon-action-suggest-biz-enabled',
		filename: 'icon-action-suggest-biz-enabled.svg',
		path: 'action/icon-action-suggest-biz-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-suggest-biz-hover-svg': {
		name: 'icon-action-suggest-biz-hover',
		filename: 'icon-action-suggest-biz-hover.svg',
		path: 'action/icon-action-suggest-biz-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-suggest-biz-pressed-svg': {
		name: 'icon-action-suggest-biz-pressed',
		filename: 'icon-action-suggest-biz-pressed.svg',
		path: 'action/icon-action-suggest-biz-pressed.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-suggest-default-enabled-svg': {
		name: 'icon-action-suggest-default-enabled',
		filename: 'icon-action-suggest-default-enabled.svg',
		path: 'action/icon-action-suggest-default-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-suggest-default-hover-svg': {
		name: 'icon-action-suggest-default-hover',
		filename: 'icon-action-suggest-default-hover.svg',
		path: 'action/icon-action-suggest-default-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-suggest-default-pressed-svg': {
		name: 'icon-action-suggest-default-pressed',
		filename: 'icon-action-suggest-default-pressed.svg',
		path: 'action/icon-action-suggest-default-pressed.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-switch-black-svg': {
		name: 'icon-action-switch-black',
		filename: 'icon-action-switch-black.svg',
		path: 'action/icon-action-switch-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-tooltip-gray-svg': {
		name: 'icon-action-tooltip-gray',
		filename: 'icon-action-tooltip-gray.svg',
		path: 'action/icon-action-tooltip-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-tracking-svg': {
		name: 'icon-action-tracking',
		filename: 'icon-action-tracking.svg',
		path: 'action/icon-action-tracking.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-upload-purple-svg': {
		name: 'icon-action-upload-purple',
		filename: 'icon-action-upload-purple.svg',
		path: 'action/icon-action-upload-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-action-upload-svg': {
		name: 'icon-action-upload',
		filename: 'icon-action-upload.svg',
		path: 'action/icon-action-upload.svg',
		extension: 'svg',
		type: 'icon',
		category: 'action',
		assetDir: 'icon',
	},
	'icon-bookmark-gray-disabled-svg': {
		name: 'icon-bookmark-gray-disabled',
		filename: 'icon-bookmark-gray-disabled.svg',
		path: 'bookmark/icon-bookmark-gray-disabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'bookmark',
		assetDir: 'icon',
	},
	'icon-bookmark-gray-enabled-svg': {
		name: 'icon-bookmark-gray-enabled',
		filename: 'icon-bookmark-gray-enabled.svg',
		path: 'bookmark/icon-bookmark-gray-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'bookmark',
		assetDir: 'icon',
	},
	'icon-bookmark-white-disabled-svg': {
		name: 'icon-bookmark-white-disabled',
		filename: 'icon-bookmark-white-disabled.svg',
		path: 'bookmark/icon-bookmark-white-disabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'bookmark',
		assetDir: 'icon',
	},
	'icon-bookmark-white-enabled-svg': {
		name: 'icon-bookmark-white-enabled',
		filename: 'icon-bookmark-white-enabled.svg',
		path: 'bookmark/icon-bookmark-white-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'bookmark',
		assetDir: 'icon',
	},
	'icon-calendar-dark-svg': {
		name: 'icon-calendar-dark',
		filename: 'icon-calendar-dark.svg',
		path: 'calendar/icon-calendar-dark.svg',
		extension: 'svg',
		type: 'icon',
		category: 'calendar',
		assetDir: 'icon',
	},
	'icon-calendar-gray-svg': {
		name: 'icon-calendar-gray',
		filename: 'icon-calendar-gray.svg',
		path: 'calendar/icon-calendar-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'calendar',
		assetDir: 'icon',
	},
	'icon-calendar-white-svg': {
		name: 'icon-calendar-white',
		filename: 'icon-calendar-white.svg',
		path: 'calendar/icon-calendar-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'calendar',
		assetDir: 'icon',
	},
	'icon-carousel-active-svg': {
		name: 'icon-carousel-active',
		filename: 'icon-carousel-active.svg',
		path: 'carousel/icon-carousel-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'carousel',
		assetDir: 'icon',
	},
	'icon-carousel-default-svg': {
		name: 'icon-carousel-default',
		filename: 'icon-carousel-default.svg',
		path: 'carousel/icon-carousel-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'carousel',
		assetDir: 'icon',
	},
	'icon-check-active-svg': {
		name: 'icon-check-active',
		filename: 'icon-check-active.svg',
		path: 'check/icon-check-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'check',
		assetDir: 'icon',
	},
	'icon-check-enabled-svg': {
		name: 'icon-check-enabled',
		filename: 'icon-check-enabled.svg',
		path: 'check/icon-check-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'check',
		assetDir: 'icon',
	},
	'icon-checkbox-purple-active-svg': {
		name: 'icon-checkbox-purple-active',
		filename: 'icon-checkbox-purple-active.svg',
		path: 'checkbox/icon-checkbox-purple-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'checkbox',
		assetDir: 'icon',
	},
	'icon-checkbox-purple-enabled-svg': {
		name: 'icon-checkbox-purple-enabled',
		filename: 'icon-checkbox-purple-enabled.svg',
		path: 'checkbox/icon-checkbox-purple-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'checkbox',
		assetDir: 'icon',
	},
	'icon-checkbox-white-active-svg': {
		name: 'icon-checkbox-white-active',
		filename: 'icon-checkbox-white-active.svg',
		path: 'checkbox/icon-checkbox-white-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'checkbox',
		assetDir: 'icon',
	},
	'icon-checkbox-white-default-svg': {
		name: 'icon-checkbox-white-default',
		filename: 'icon-checkbox-white-default.svg',
		path: 'checkbox/icon-checkbox-white-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'checkbox',
		assetDir: 'icon',
	},
	'icon-checkbox-white-hover-svg': {
		name: 'icon-checkbox-white-hover',
		filename: 'icon-checkbox-white-hover.svg',
		path: 'checkbox/icon-checkbox-white-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'checkbox',
		assetDir: 'icon',
	},
	'icon-country-global-svg': {
		name: 'icon-country-global',
		filename: 'icon-country-global.svg',
		path: 'country/icon-country-global.svg',
		extension: 'svg',
		type: 'icon',
		category: 'country',
		assetDir: 'icon',
	},
	'icon-country-image-svg': {
		name: 'icon-country-image',
		filename: 'icon-country-image.svg',
		path: 'country/icon-country-image.svg',
		extension: 'svg',
		type: 'icon',
		category: 'country',
		assetDir: 'icon',
	},
	'icon-country-location-svg': {
		name: 'icon-country-location',
		filename: 'icon-country-location.svg',
		path: 'country/icon-country-location.svg',
		extension: 'svg',
		type: 'icon',
		category: 'country',
		assetDir: 'icon',
	},
	'icon-hashtag-black-svg': {
		name: 'icon-hashtag-black',
		filename: 'icon-hashtag-black.svg',
		path: 'hashtag/icon-hashtag-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'hashtag',
		assetDir: 'icon',
	},
	'icon-hashtag-white-svg': {
		name: 'icon-hashtag-white',
		filename: 'icon-hashtag-white.svg',
		path: 'hashtag/icon-hashtag-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'hashtag',
		assetDir: 'icon',
	},
	'icon-mark-auth-svg': {
		name: 'icon-mark-auth',
		filename: 'icon-mark-auth.svg',
		path: 'mark/icon-mark-auth.svg',
		extension: 'svg',
		type: 'icon',
		category: 'mark',
		assetDir: 'icon',
	},
	'icon-mark-biz-svg': {
		name: 'icon-mark-biz',
		filename: 'icon-mark-biz.svg',
		path: 'mark/icon-mark-biz.svg',
		extension: 'svg',
		type: 'icon',
		category: 'mark',
		assetDir: 'icon',
	},
	'icon-my-left-svg': {
		name: 'icon-my-left',
		filename: 'icon-my-left.svg',
		path: 'my/icon-my-left.svg',
		extension: 'svg',
		type: 'icon',
		category: 'my',
		assetDir: 'icon',
	},
	'icon-my-right-svg': {
		name: 'icon-my-right',
		filename: 'icon-my-right.svg',
		path: 'my/icon-my-right.svg',
		extension: 'svg',
		type: 'icon',
		category: 'my',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-black-down-svg': {
		name: 'icon-navigation-chevron-black-down',
		filename: 'icon-navigation-chevron-black-down.svg',
		path: 'navigation/icon-navigation-chevron-black-down.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-black-left-lg-svg': {
		name: 'icon-navigation-chevron-black-left-lg',
		filename: 'icon-navigation-chevron-black-left-lg.svg',
		path: 'navigation/icon-navigation-chevron-black-left-lg.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-black-left-sm-svg': {
		name: 'icon-navigation-chevron-black-left-sm',
		filename: 'icon-navigation-chevron-black-left-sm.svg',
		path: 'navigation/icon-navigation-chevron-black-left-sm.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-black-right-lg-svg': {
		name: 'icon-navigation-chevron-black-right-lg',
		filename: 'icon-navigation-chevron-black-right-lg.svg',
		path: 'navigation/icon-navigation-chevron-black-right-lg.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-black-right-sm-svg': {
		name: 'icon-navigation-chevron-black-right-sm',
		filename: 'icon-navigation-chevron-black-right-sm.svg',
		path: 'navigation/icon-navigation-chevron-black-right-sm.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-black-up-lg-svg': {
		name: 'icon-navigation-chevron-black-up-lg',
		filename: 'icon-navigation-chevron-black-up-lg.svg',
		path: 'navigation/icon-navigation-chevron-black-up-lg.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-black-up-sm-svg': {
		name: 'icon-navigation-chevron-black-up-sm',
		filename: 'icon-navigation-chevron-black-up-sm.svg',
		path: 'navigation/icon-navigation-chevron-black-up-sm.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-cash-down-svg': {
		name: 'icon-navigation-chevron-cash-down',
		filename: 'icon-navigation-chevron-cash-down.svg',
		path: 'navigation/icon-navigation-chevron-cash-down.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-casual-down-svg': {
		name: 'icon-navigation-chevron-casual-down',
		filename: 'icon-navigation-chevron-casual-down.svg',
		path: 'navigation/icon-navigation-chevron-casual-down.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-gray-left-svg': {
		name: 'icon-navigation-chevron-gray-left',
		filename: 'icon-navigation-chevron-gray-left.svg',
		path: 'navigation/icon-navigation-chevron-gray-left.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-gray-right-svg': {
		name: 'icon-navigation-chevron-gray-right',
		filename: 'icon-navigation-chevron-gray-right.svg',
		path: 'navigation/icon-navigation-chevron-gray-right.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-purple-left-lg-svg': {
		name: 'icon-navigation-chevron-purple-left-lg',
		filename: 'icon-navigation-chevron-purple-left-lg.svg',
		path: 'navigation/icon-navigation-chevron-purple-left-lg.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-purple-left-sm-svg': {
		name: 'icon-navigation-chevron-purple-left-sm',
		filename: 'icon-navigation-chevron-purple-left-sm.svg',
		path: 'navigation/icon-navigation-chevron-purple-left-sm.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-purple-right-lg-svg': {
		name: 'icon-navigation-chevron-purple-right-lg',
		filename: 'icon-navigation-chevron-purple-right-lg.svg',
		path: 'navigation/icon-navigation-chevron-purple-right-lg.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-purple-right-sm-svg': {
		name: 'icon-navigation-chevron-purple-right-sm',
		filename: 'icon-navigation-chevron-purple-right-sm.svg',
		path: 'navigation/icon-navigation-chevron-purple-right-sm.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-white-down-svg': {
		name: 'icon-navigation-chevron-white-down',
		filename: 'icon-navigation-chevron-white-down.svg',
		path: 'navigation/icon-navigation-chevron-white-down.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-white-left-lg-svg': {
		name: 'icon-navigation-chevron-white-left-lg',
		filename: 'icon-navigation-chevron-white-left-lg.svg',
		path: 'navigation/icon-navigation-chevron-white-left-lg.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-white-left-sm-svg': {
		name: 'icon-navigation-chevron-white-left-sm',
		filename: 'icon-navigation-chevron-white-left-sm.svg',
		path: 'navigation/icon-navigation-chevron-white-left-sm.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-white-right-lg-svg': {
		name: 'icon-navigation-chevron-white-right-lg',
		filename: 'icon-navigation-chevron-white-right-lg.svg',
		path: 'navigation/icon-navigation-chevron-white-right-lg.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-white-right-sm-svg': {
		name: 'icon-navigation-chevron-white-right-sm',
		filename: 'icon-navigation-chevron-white-right-sm.svg',
		path: 'navigation/icon-navigation-chevron-white-right-sm.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-chevron-white-up-svg': {
		name: 'icon-navigation-chevron-white-up',
		filename: 'icon-navigation-chevron-white-up.svg',
		path: 'navigation/icon-navigation-chevron-white-up.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-close-black-small-svg': {
		name: 'icon-navigation-close-black-small',
		filename: 'icon-navigation-close-black-small.svg',
		path: 'navigation/icon-navigation-close-black-small.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-close-black-svg': {
		name: 'icon-navigation-close-black',
		filename: 'icon-navigation-close-black.svg',
		path: 'navigation/icon-navigation-close-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-close-white-small-svg': {
		name: 'icon-navigation-close-white-small',
		filename: 'icon-navigation-close-white-small.svg',
		path: 'navigation/icon-navigation-close-white-small.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-navigation-close-white-svg': {
		name: 'icon-navigation-close-white',
		filename: 'icon-navigation-close-white.svg',
		path: 'navigation/icon-navigation-close-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'navigation',
		assetDir: 'icon',
	},
	'icon-personnel-icon-personnel-png': {
		name: 'icon-personnel-icon-personnel',
		filename: 'icon-personnel-icon-personnel.png',
		path: 'personnel/icon-personnel-icon-personnel.png',
		extension: 'png',
		type: 'image',
		category: 'personnel',
		assetDir: 'icon',
	},
	'icon-personnel-icon-personnel-svg': {
		name: 'icon-personnel-icon-personnel',
		filename: 'icon-personnel-icon-personnel.svg',
		path: 'personnel/icon-personnel-icon-personnel.svg',
		extension: 'svg',
		type: 'icon',
		category: 'personnel',
		assetDir: 'icon',
	},
	'icon-play-play-svg': {
		name: 'icon-play-play',
		filename: 'icon-play-play.svg',
		path: 'play/icon-play-play.svg',
		extension: 'svg',
		type: 'icon',
		category: 'play',
		assetDir: 'icon',
	},
	'icon-radio-active-svg': {
		name: 'icon-radio-active',
		filename: 'icon-radio-active.svg',
		path: 'radio/icon-radio-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'radio',
		assetDir: 'icon',
	},
	'icon-radio-enabled-svg': {
		name: 'icon-radio-enabled',
		filename: 'icon-radio-enabled.svg',
		path: 'radio/icon-radio-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'radio',
		assetDir: 'icon',
	},
	'icon-scale-default-svg': {
		name: 'icon-scale-default',
		filename: 'icon-scale-default.svg',
		path: 'scale/icon-scale-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'scale',
		assetDir: 'icon',
	},
	'icon-scale-pressed-svg': {
		name: 'icon-scale-pressed',
		filename: 'icon-scale-pressed.svg',
		path: 'scale/icon-scale-pressed.svg',
		extension: 'svg',
		type: 'icon',
		category: 'scale',
		assetDir: 'icon',
	},
	'icon-score-a-png': {
		name: 'icon-score-a',
		filename: 'icon-score-a.png',
		path: 'score/icon-score-a.png',
		extension: 'png',
		type: 'image',
		category: 'score',
		assetDir: 'icon',
	},
	'icon-score-b-png': {
		name: 'icon-score-b',
		filename: 'icon-score-b.png',
		path: 'score/icon-score-b.png',
		extension: 'png',
		type: 'image',
		category: 'score',
		assetDir: 'icon',
	},
	'icon-score-c-png': {
		name: 'icon-score-c',
		filename: 'icon-score-c.png',
		path: 'score/icon-score-c.png',
		extension: 'png',
		type: 'image',
		category: 'score',
		assetDir: 'icon',
	},
	'icon-score-d-png': {
		name: 'icon-score-d',
		filename: 'icon-score-d.png',
		path: 'score/icon-score-d.png',
		extension: 'png',
		type: 'image',
		category: 'score',
		assetDir: 'icon',
	},
	'icon-score-f-png': {
		name: 'icon-score-f',
		filename: 'icon-score-f.png',
		path: 'score/icon-score-f.png',
		extension: 'png',
		type: 'image',
		category: 'score',
		assetDir: 'icon',
	},
	'icon-score-s-plus-png': {
		name: 'icon-score-s-plus',
		filename: 'icon-score-s-plus.png',
		path: 'score/icon-score-s-plus.png',
		extension: 'png',
		type: 'image',
		category: 'score',
		assetDir: 'icon',
	},
	'icon-score-s-png': {
		name: 'icon-score-s',
		filename: 'icon-score-s.png',
		path: 'score/icon-score-s.png',
		extension: 'png',
		type: 'image',
		category: 'score',
		assetDir: 'icon',
	},
	'icon-search-gray-svg': {
		name: 'icon-search-gray',
		filename: 'icon-search-gray.svg',
		path: 'search/icon-search-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'search',
		assetDir: 'icon',
	},
	'icon-search-purple-svg': {
		name: 'icon-search-purple',
		filename: 'icon-search-purple.svg',
		path: 'search/icon-search-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'search',
		assetDir: 'icon',
	},
	'icon-search-white-svg': {
		name: 'icon-search-white',
		filename: 'icon-search-white.svg',
		path: 'search/icon-search-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'search',
		assetDir: 'icon',
	},
	'icon-sign-clear-svg': {
		name: 'icon-sign-clear',
		filename: 'icon-sign-clear.svg',
		path: 'sign/icon-sign-clear.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sign-colon-svg': {
		name: 'icon-sign-colon',
		filename: 'icon-sign-colon.svg',
		path: 'sign/icon-sign-colon.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sign-dance-list-svg': {
		name: 'icon-sign-dance-list',
		filename: 'icon-sign-dance-list.svg',
		path: 'sign/icon-sign-dance-list.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sign-file-svg': {
		name: 'icon-sign-file',
		filename: 'icon-sign-file.svg',
		path: 'sign/icon-sign-file.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sign-plus-svg': {
		name: 'icon-sign-plus',
		filename: 'icon-sign-plus.svg',
		path: 'sign/icon-sign-plus.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sign-red-dot-svg': {
		name: 'icon-sign-red-dot',
		filename: 'icon-sign-red-dot.svg',
		path: 'sign/icon-sign-red-dot.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sign-upload-purple-svg': {
		name: 'icon-sign-upload-purple',
		filename: 'icon-sign-upload-purple.svg',
		path: 'sign/icon-sign-upload-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sign-upload-red-svg': {
		name: 'icon-sign-upload-red',
		filename: 'icon-sign-upload-red.svg',
		path: 'sign/icon-sign-upload-red.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sign-upload-white-svg': {
		name: 'icon-sign-upload-white',
		filename: 'icon-sign-upload-white.svg',
		path: 'sign/icon-sign-upload-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sign-view-count-svg': {
		name: 'icon-sign-view-count',
		filename: 'icon-sign-view-count.svg',
		path: 'sign/icon-sign-view-count.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sign',
		assetDir: 'icon',
	},
	'icon-sns-apple-svg': {
		name: 'icon-sns-apple',
		filename: 'icon-sns-apple.svg',
		path: 'sns/icon-sns-apple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sns',
		assetDir: 'icon',
	},
	'icon-sns-email-svg': {
		name: 'icon-sns-email',
		filename: 'icon-sns-email.svg',
		path: 'sns/icon-sns-email.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sns',
		assetDir: 'icon',
	},
	'icon-sns-google-svg': {
		name: 'icon-sns-google',
		filename: 'icon-sns-google.svg',
		path: 'sns/icon-sns-google.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sns',
		assetDir: 'icon',
	},
	'icon-social-apple-svg': {
		name: 'icon-social-apple',
		filename: 'icon-social-apple.svg',
		path: 'social/icon-social-apple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-block-svg': {
		name: 'icon-social-block',
		filename: 'icon-social-block.svg',
		path: 'social/icon-social-block.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-boost-active-svg': {
		name: 'icon-social-boost-active',
		filename: 'icon-social-boost-active.svg',
		path: 'social/icon-social-boost-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-boost-default-svg': {
		name: 'icon-social-boost-default',
		filename: 'icon-social-boost-default.svg',
		path: 'social/icon-social-boost-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-boost-hide-svg': {
		name: 'icon-social-boost-hide',
		filename: 'icon-social-boost-hide.svg',
		path: 'social/icon-social-boost-hide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-boost-unhide-svg': {
		name: 'icon-social-boost-unhide',
		filename: 'icon-social-boost-unhide.svg',
		path: 'social/icon-social-boost-unhide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-cash-svg': {
		name: 'icon-social-cash',
		filename: 'icon-social-cash.svg',
		path: 'social/icon-social-cash.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-casual-svg': {
		name: 'icon-social-casual',
		filename: 'icon-social-casual.svg',
		path: 'social/icon-social-casual.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-comment-active-svg': {
		name: 'icon-social-comment-active',
		filename: 'icon-social-comment-active.svg',
		path: 'social/icon-social-comment-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-comment-default-svg': {
		name: 'icon-social-comment-default',
		filename: 'icon-social-comment-default.svg',
		path: 'social/icon-social-comment-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-comment-hide-svg': {
		name: 'icon-social-comment-hide',
		filename: 'icon-social-comment-hide.svg',
		path: 'social/icon-social-comment-hide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-comment-unhide-svg': {
		name: 'icon-social-comment-unhide',
		filename: 'icon-social-comment-unhide.svg',
		path: 'social/icon-social-comment-unhide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-download-svg': {
		name: 'icon-social-download',
		filename: 'icon-social-download.svg',
		path: 'social/icon-social-download.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-email-svg': {
		name: 'icon-social-email',
		filename: 'icon-social-email.svg',
		path: 'social/icon-social-email.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-facebook-svg': {
		name: 'icon-social-facebook',
		filename: 'icon-social-facebook.svg',
		path: 'social/icon-social-facebook.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-follow-follow-svg': {
		name: 'icon-social-follow-follow',
		filename: 'icon-social-follow-follow.svg',
		path: 'social/icon-social-follow-follow.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-follow-unfollow-svg': {
		name: 'icon-social-follow-unfollow',
		filename: 'icon-social-follow-unfollow.svg',
		path: 'social/icon-social-follow-unfollow.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-google-svg': {
		name: 'icon-social-google',
		filename: 'icon-social-google.svg',
		path: 'social/icon-social-google.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-hide-svg': {
		name: 'icon-social-hide',
		filename: 'icon-social-hide.svg',
		path: 'social/icon-social-hide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-like-active-svg': {
		name: 'icon-social-like-active',
		filename: 'icon-social-like-active.svg',
		path: 'social/icon-social-like-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-like-default-svg': {
		name: 'icon-social-like-default',
		filename: 'icon-social-like-default.svg',
		path: 'social/icon-social-like-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-like-hide-svg': {
		name: 'icon-social-like-hide',
		filename: 'icon-social-like-hide.svg',
		path: 'social/icon-social-like-hide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-like-unhide-svg': {
		name: 'icon-social-like-unhide',
		filename: 'icon-social-like-unhide.svg',
		path: 'social/icon-social-like-unhide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-meatball-svg': {
		name: 'icon-social-meatball',
		filename: 'icon-social-meatball.svg',
		path: 'social/icon-social-meatball.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-modify-svg': {
		name: 'icon-social-modify',
		filename: 'icon-social-modify.svg',
		path: 'social/icon-social-modify.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-profile-contents-profile-add-svg': {
		name: 'icon-social-profile-contents-profile-add',
		filename: 'icon-social-profile-contents-profile-add.svg',
		path: 'social/icon-social-profile-contents-profile-add.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-settings-upload-svg': {
		name: 'icon-social-settings-upload',
		filename: 'icon-social-settings-upload.svg',
		path: 'social/icon-social-settings-upload.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-share-svg': {
		name: 'icon-social-share',
		filename: 'icon-social-share.svg',
		path: 'social/icon-social-share.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-thumbtack-black-off-svg': {
		name: 'icon-social-thumbtack-black-off',
		filename: 'icon-social-thumbtack-black-off.svg',
		path: 'social/icon-social-thumbtack-black-off.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-thumbtack-black-on-svg': {
		name: 'icon-social-thumbtack-black-on',
		filename: 'icon-social-thumbtack-black-on.svg',
		path: 'social/icon-social-thumbtack-black-on.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-thumbtack-white-svg': {
		name: 'icon-social-thumbtack-white',
		filename: 'icon-social-thumbtack-white.svg',
		path: 'social/icon-social-thumbtack-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-unhide-svg': {
		name: 'icon-social-unhide',
		filename: 'icon-social-unhide.svg',
		path: 'social/icon-social-unhide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-view-black-hide-svg': {
		name: 'icon-social-view-black-hide',
		filename: 'icon-social-view-black-hide.svg',
		path: 'social/icon-social-view-black-hide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-view-black-unhide-svg': {
		name: 'icon-social-view-black-unhide',
		filename: 'icon-social-view-black-unhide.svg',
		path: 'social/icon-social-view-black-unhide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-view-purple-hide-svg': {
		name: 'icon-social-view-purple-hide',
		filename: 'icon-social-view-purple-hide.svg',
		path: 'social/icon-social-view-purple-hide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-view-purple-unhide-svg': {
		name: 'icon-social-view-purple-unhide',
		filename: 'icon-social-view-purple-unhide.svg',
		path: 'social/icon-social-view-purple-unhide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-view-white-hide-svg': {
		name: 'icon-social-view-white-hide',
		filename: 'icon-social-view-white-hide.svg',
		path: 'social/icon-social-view-white-hide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-social-view-white-unhide-svg': {
		name: 'icon-social-view-white-unhide',
		filename: 'icon-social-view-white-unhide.svg',
		path: 'social/icon-social-view-white-unhide.svg',
		extension: 'svg',
		type: 'icon',
		category: 'social',
		assetDir: 'icon',
	},
	'icon-sticker-1st-png': {
		name: 'icon-sticker-1st',
		filename: 'icon-sticker-1st.png',
		path: 'sticker/icon-sticker-1st.png',
		extension: 'png',
		type: 'image',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-2nd-png': {
		name: 'icon-sticker-2nd',
		filename: 'icon-sticker-2nd.png',
		path: 'sticker/icon-sticker-2nd.png',
		extension: 'png',
		type: 'image',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-3rd-png': {
		name: 'icon-sticker-3rd',
		filename: 'icon-sticker-3rd.png',
		path: 'sticker/icon-sticker-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-4th-png': {
		name: 'icon-sticker-4th',
		filename: 'icon-sticker-4th.png',
		path: 'sticker/icon-sticker-4th.png',
		extension: 'png',
		type: 'image',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-account-svg': {
		name: 'icon-sticker-account',
		filename: 'icon-sticker-account.svg',
		path: 'sticker/icon-sticker-account.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-block-red-svg': {
		name: 'icon-sticker-block-red',
		filename: 'icon-sticker-block-red.svg',
		path: 'sticker/icon-sticker-block-red.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-business-crown-png': {
		name: 'icon-sticker-business-crown',
		filename: 'icon-sticker-business-crown.png',
		path: 'sticker/icon-sticker-business-crown.png',
		extension: 'png',
		type: 'image',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-business-svg': {
		name: 'icon-sticker-business',
		filename: 'icon-sticker-business.svg',
		path: 'sticker/icon-sticker-business.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-certify-svg': {
		name: 'icon-sticker-certify',
		filename: 'icon-sticker-certify.svg',
		path: 'sticker/icon-sticker-certify.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-colon-disabled-svg': {
		name: 'icon-sticker-colon-disabled',
		filename: 'icon-sticker-colon-disabled.svg',
		path: 'sticker/icon-sticker-colon-disabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-colon-enabled-svg': {
		name: 'icon-sticker-colon-enabled',
		filename: 'icon-sticker-colon-enabled.svg',
		path: 'sticker/icon-sticker-colon-enabled.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-connect-svg': {
		name: 'icon-sticker-connect',
		filename: 'icon-sticker-connect.svg',
		path: 'sticker/icon-sticker-connect.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-connection-svg': {
		name: 'icon-sticker-connection',
		filename: 'icon-sticker-connection.svg',
		path: 'sticker/icon-sticker-connection.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-delete-active-svg': {
		name: 'icon-sticker-delete-active',
		filename: 'icon-sticker-delete-active.svg',
		path: 'sticker/icon-sticker-delete-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-error-rectangle-svg': {
		name: 'icon-sticker-error-rectangle',
		filename: 'icon-sticker-error-rectangle.svg',
		path: 'sticker/icon-sticker-error-rectangle.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-error-round-svg': {
		name: 'icon-sticker-error-round',
		filename: 'icon-sticker-error-round.svg',
		path: 'sticker/icon-sticker-error-round.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-fail-svg': {
		name: 'icon-sticker-fail',
		filename: 'icon-sticker-fail.svg',
		path: 'sticker/icon-sticker-fail.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-global-png': {
		name: 'icon-sticker-global',
		filename: 'icon-sticker-global.png',
		path: 'sticker/icon-sticker-global.png',
		extension: 'png',
		type: 'image',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-korea-png': {
		name: 'icon-sticker-korea',
		filename: 'icon-sticker-korea.png',
		path: 'sticker/icon-sticker-korea.png',
		extension: 'png',
		type: 'image',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-logo-loading-svg': {
		name: 'icon-sticker-logo-loading',
		filename: 'icon-sticker-logo-loading.svg',
		path: 'sticker/icon-sticker-logo-loading.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-must-svg': {
		name: 'icon-sticker-must',
		filename: 'icon-sticker-must.svg',
		path: 'sticker/icon-sticker-must.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-report-svg': {
		name: 'icon-sticker-report',
		filename: 'icon-sticker-report.svg',
		path: 'sticker/icon-sticker-report.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-select-png': {
		name: 'icon-sticker-select',
		filename: 'icon-sticker-select.png',
		path: 'sticker/icon-sticker-select.png',
		extension: 'png',
		type: 'image',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-song-gray-svg': {
		name: 'icon-sticker-song-gray',
		filename: 'icon-sticker-song-gray.svg',
		path: 'sticker/icon-sticker-song-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-song-purple-svg': {
		name: 'icon-sticker-song-purple',
		filename: 'icon-sticker-song-purple.svg',
		path: 'sticker/icon-sticker-song-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-success-svg': {
		name: 'icon-sticker-success',
		filename: 'icon-sticker-success.svg',
		path: 'sticker/icon-sticker-success.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-timer-black-svg': {
		name: 'icon-sticker-timer-black',
		filename: 'icon-sticker-timer-black.svg',
		path: 'sticker/icon-sticker-timer-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-sticker-timer-red-svg': {
		name: 'icon-sticker-timer-red',
		filename: 'icon-sticker-timer-red.svg',
		path: 'sticker/icon-sticker-timer-red.svg',
		extension: 'svg',
		type: 'icon',
		category: 'sticker',
		assetDir: 'icon',
	},
	'icon-tab-application-active-svg': {
		name: 'icon-tab-application-active',
		filename: 'icon-tab-application-active.svg',
		path: 'tab/icon-tab-application-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-application-default-svg': {
		name: 'icon-tab-application-default',
		filename: 'icon-tab-application-default.svg',
		path: 'tab/icon-tab-application-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-application-hover-svg': {
		name: 'icon-tab-application-hover',
		filename: 'icon-tab-application-hover.svg',
		path: 'tab/icon-tab-application-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-biz-account-active-svg': {
		name: 'icon-tab-biz-account-active',
		filename: 'icon-tab-biz-account-active.svg',
		path: 'tab/icon-tab-biz-account-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-biz-account-default-svg': {
		name: 'icon-tab-biz-account-default',
		filename: 'icon-tab-biz-account-default.svg',
		path: 'tab/icon-tab-biz-account-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-biz-account-hover-svg': {
		name: 'icon-tab-biz-account-hover',
		filename: 'icon-tab-biz-account-hover.svg',
		path: 'tab/icon-tab-biz-account-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-create-active-svg': {
		name: 'icon-tab-create-active',
		filename: 'icon-tab-create-active.svg',
		path: 'tab/icon-tab-create-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-create-default-svg': {
		name: 'icon-tab-create-default',
		filename: 'icon-tab-create-default.svg',
		path: 'tab/icon-tab-create-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-create-hover-svg': {
		name: 'icon-tab-create-hover',
		filename: 'icon-tab-create-hover.svg',
		path: 'tab/icon-tab-create-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-manage-active-svg': {
		name: 'icon-tab-manage-active',
		filename: 'icon-tab-manage-active.svg',
		path: 'tab/icon-tab-manage-active.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-manage-default-svg': {
		name: 'icon-tab-manage-default',
		filename: 'icon-tab-manage-default.svg',
		path: 'tab/icon-tab-manage-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tab-manage-hover-svg': {
		name: 'icon-tab-manage-hover',
		filename: 'icon-tab-manage-hover.svg',
		path: 'tab/icon-tab-manage-hover.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'icon',
	},
	'icon-tracking-default-svg': {
		name: 'icon-tracking-default',
		filename: 'icon-tracking-default.svg',
		path: 'tracking/icon-tracking-default.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tracking',
		assetDir: 'icon',
	},
	'icon-tracking-pressed-svg': {
		name: 'icon-tracking-pressed',
		filename: 'icon-tracking-pressed.svg',
		path: 'tracking/icon-tracking-pressed.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tracking',
		assetDir: 'icon',
	},
	'payment-payment-boost-png': {
		name: 'payment-payment-boost',
		filename: 'payment-payment-boost.png',
		path: 'payment/payment-payment-boost.png',
		extension: 'png',
		type: 'image',
		category: 'payment',
		assetDir: 'payment',
	},
	'payment-payment-diamond-png': {
		name: 'payment-payment-diamond',
		filename: 'payment-payment-diamond.png',
		path: 'payment/payment-payment-diamond.png',
		extension: 'png',
		type: 'image',
		category: 'payment',
		assetDir: 'payment',
	},
	'payment-payment-dollar-png': {
		name: 'payment-payment-dollar',
		filename: 'payment-payment-dollar.png',
		path: 'payment/payment-payment-dollar.png',
		extension: 'png',
		type: 'image',
		category: 'payment',
		assetDir: 'payment',
	},
	'payment-payment-energy-png': {
		name: 'payment-payment-energy',
		filename: 'payment-payment-energy.png',
		path: 'payment/payment-payment-energy.png',
		extension: 'png',
		type: 'image',
		category: 'payment',
		assetDir: 'payment',
	},
	'payment-payment-gold-png': {
		name: 'payment-payment-gold',
		filename: 'payment-payment-gold.png',
		path: 'payment/payment-payment-gold.png',
		extension: 'png',
		type: 'image',
		category: 'payment',
		assetDir: 'payment',
	},
	'payment-prize-left-png': {
		name: 'payment-prize-left',
		filename: 'payment-prize-left.png',
		path: 'prize/payment-prize-left.png',
		extension: 'png',
		type: 'image',
		category: 'prize',
		assetDir: 'payment',
	},
	'payment-prize-right-png': {
		name: 'payment-prize-right',
		filename: 'payment-prize-right.png',
		path: 'prize/payment-prize-right.png',
		extension: 'png',
		type: 'image',
		category: 'prize',
		assetDir: 'payment',
	},
	'payment-symbol-ca-png': {
		name: 'payment-symbol-ca',
		filename: 'payment-symbol-ca.png',
		path: 'symbol/payment-symbol-ca.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-en-png': {
		name: 'payment-symbol-en',
		filename: 'payment-symbol-en.png',
		path: 'symbol/payment-symbol-en.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-eu-png': {
		name: 'payment-symbol-eu',
		filename: 'payment-symbol-eu.png',
		path: 'symbol/payment-symbol-eu.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-gb-png': {
		name: 'payment-symbol-gb',
		filename: 'payment-symbol-gb.png',
		path: 'symbol/payment-symbol-gb.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-hk-png': {
		name: 'payment-symbol-hk',
		filename: 'payment-symbol-hk.png',
		path: 'symbol/payment-symbol-hk.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-id-png': {
		name: 'payment-symbol-id',
		filename: 'payment-symbol-id.png',
		path: 'symbol/payment-symbol-id.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-in-png': {
		name: 'payment-symbol-in',
		filename: 'payment-symbol-in.png',
		path: 'symbol/payment-symbol-in.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-ja-png': {
		name: 'payment-symbol-ja',
		filename: 'payment-symbol-ja.png',
		path: 'symbol/payment-symbol-ja.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-ko-png': {
		name: 'payment-symbol-ko',
		filename: 'payment-symbol-ko.png',
		path: 'symbol/payment-symbol-ko.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-ms-png': {
		name: 'payment-symbol-ms',
		filename: 'payment-symbol-ms.png',
		path: 'symbol/payment-symbol-ms.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-ph-png': {
		name: 'payment-symbol-ph',
		filename: 'payment-symbol-ph.png',
		path: 'symbol/payment-symbol-ph.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-th-png': {
		name: 'payment-symbol-th',
		filename: 'payment-symbol-th.png',
		path: 'symbol/payment-symbol-th.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'payment-symbol-vi-png': {
		name: 'payment-symbol-vi',
		filename: 'payment-symbol-vi.png',
		path: 'symbol/payment-symbol-vi.png',
		extension: 'png',
		type: 'image',
		category: 'symbol',
		assetDir: 'payment',
	},
	'tournament-bracket-title-3rd-dimmed-png': {
		name: 'tournament-bracket-title-3rd-dimmed',
		filename: 'tournament-bracket-title-3rd-dimmed.png',
		path: 'bracket/title/tournament-bracket-title-3rd-dimmed.png',
		extension: 'png',
		type: 'image',
		category: 'bracket',
		assetDir: 'tournament',
	},
	'tournament-bracket-title-3rd-png': {
		name: 'tournament-bracket-title-3rd',
		filename: 'tournament-bracket-title-3rd.png',
		path: 'bracket/title/tournament-bracket-title-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'bracket',
		assetDir: 'tournament',
	},
	'tournament-bracket-title-finals-png': {
		name: 'tournament-bracket-title-finals',
		filename: 'tournament-bracket-title-finals.png',
		path: 'bracket/title/tournament-bracket-title-finals.png',
		extension: 'png',
		type: 'image',
		category: 'bracket',
		assetDir: 'tournament',
	},
	'tournament-bracket-title-semi-png': {
		name: 'tournament-bracket-title-semi',
		filename: 'tournament-bracket-title-semi.png',
		path: 'bracket/title/tournament-bracket-title-semi.png',
		extension: 'png',
		type: 'image',
		category: 'bracket',
		assetDir: 'tournament',
	},
	'tournament-bracket-title-title-png': {
		name: 'tournament-bracket-title-title',
		filename: 'tournament-bracket-title-title.png',
		path: 'bracket/title/tournament-bracket-title-title.png',
		extension: 'png',
		type: 'image',
		category: 'bracket',
		assetDir: 'tournament',
	},
	'tournament-bracket-vs-finals-png': {
		name: 'tournament-bracket-vs-finals',
		filename: 'tournament-bracket-vs-finals.png',
		path: 'bracket/vs/tournament-bracket-vs-finals.png',
		extension: 'png',
		type: 'image',
		category: 'bracket',
		assetDir: 'tournament',
	},
	'tournament-bracket-vs-frame-png': {
		name: 'tournament-bracket-vs-frame',
		filename: 'tournament-bracket-vs-frame.png',
		path: 'bracket/vs/tournament-bracket-vs-frame.png',
		extension: 'png',
		type: 'image',
		category: 'bracket',
		assetDir: 'tournament',
	},
	'tournament-icon-bracket-svg': {
		name: 'tournament-icon-bracket',
		filename: 'tournament-icon-bracket.svg',
		path: 'icon/tournament-icon-bracket.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-download-png': {
		name: 'tournament-icon-download',
		filename: 'tournament-icon-download.png',
		path: 'icon/tournament-icon-download.png',
		extension: 'png',
		type: 'image',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-event-black-svg': {
		name: 'tournament-icon-event-black',
		filename: 'tournament-icon-event-black.svg',
		path: 'icon/tournament-icon-event-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-event-white-svg': {
		name: 'tournament-icon-event-white',
		filename: 'tournament-icon-event-white.svg',
		path: 'icon/tournament-icon-event-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-invite-black-svg': {
		name: 'tournament-icon-invite-black',
		filename: 'tournament-icon-invite-black.svg',
		path: 'icon/tournament-icon-invite-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-invite-white-svg': {
		name: 'tournament-icon-invite-white',
		filename: 'tournament-icon-invite-white.svg',
		path: 'icon/tournament-icon-invite-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-list-svg': {
		name: 'tournament-icon-list',
		filename: 'tournament-icon-list.svg',
		path: 'icon/tournament-icon-list.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-play-circle-png': {
		name: 'tournament-icon-play-circle',
		filename: 'tournament-icon-play-circle.png',
		path: 'icon/tournament-icon-play-circle.png',
		extension: 'png',
		type: 'image',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-private-png': {
		name: 'tournament-icon-private',
		filename: 'tournament-icon-private.png',
		path: 'icon/tournament-icon-private.png',
		extension: 'png',
		type: 'image',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-public-png': {
		name: 'tournament-icon-public',
		filename: 'tournament-icon-public.png',
		path: 'icon/tournament-icon-public.png',
		extension: 'png',
		type: 'image',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-qualify-black-svg': {
		name: 'tournament-icon-qualify-black',
		filename: 'tournament-icon-qualify-black.svg',
		path: 'icon/tournament-icon-qualify-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-qualify-white-svg': {
		name: 'tournament-icon-qualify-white',
		filename: 'tournament-icon-qualify-white.svg',
		path: 'icon/tournament-icon-qualify-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-scaleup-png': {
		name: 'tournament-icon-scaleup',
		filename: 'tournament-icon-scaleup.png',
		path: 'icon/tournament-icon-scaleup.png',
		extension: 'png',
		type: 'image',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-see-less-svg': {
		name: 'tournament-icon-see-less',
		filename: 'tournament-icon-see-less.svg',
		path: 'icon/tournament-icon-see-less.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-see-more-svg': {
		name: 'tournament-icon-see-more',
		filename: 'tournament-icon-see-more.svg',
		path: 'icon/tournament-icon-see-more.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-series-black-svg': {
		name: 'tournament-icon-series-black',
		filename: 'tournament-icon-series-black.svg',
		path: 'icon/tournament-icon-series-black.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-icon-series-white-svg': {
		name: 'tournament-icon-series-white',
		filename: 'tournament-icon-series-white.svg',
		path: 'icon/tournament-icon-series-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'icon',
		assetDir: 'tournament',
	},
	'tournament-images-backgroundColorTooltip-png': {
		name: 'tournament-images-backgroundColorTooltip',
		filename: 'tournament-images-backgroundColorTooltip.png',
		path: 'images/tournament-images-backgroundColorTooltip.png',
		extension: 'png',
		type: 'image',
		category: 'images',
		assetDir: 'tournament',
	},
	'tournament-images-songListTooltip-png': {
		name: 'tournament-images-songListTooltip',
		filename: 'tournament-images-songListTooltip.png',
		path: 'images/tournament-images-songListTooltip.png',
		extension: 'png',
		type: 'image',
		category: 'images',
		assetDir: 'tournament',
	},
	'tournament-medal-1st-png': {
		name: 'tournament-medal-1st',
		filename: 'tournament-medal-1st.png',
		path: 'medal/tournament-medal-1st.png',
		extension: 'png',
		type: 'image',
		category: 'medal',
		assetDir: 'tournament',
	},
	'tournament-medal-2nd-png': {
		name: 'tournament-medal-2nd',
		filename: 'tournament-medal-2nd.png',
		path: 'medal/tournament-medal-2nd.png',
		extension: 'png',
		type: 'image',
		category: 'medal',
		assetDir: 'tournament',
	},
	'tournament-medal-3rd-png': {
		name: 'tournament-medal-3rd',
		filename: 'tournament-medal-3rd.png',
		path: 'medal/tournament-medal-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'medal',
		assetDir: 'tournament',
	},
	'tournament-onAir-off-svg': {
		name: 'tournament-onAir-off',
		filename: 'tournament-onAir-off.svg',
		path: 'onAir/tournament-onAir-off.svg',
		extension: 'svg',
		type: 'icon',
		category: 'onAir',
		assetDir: 'tournament',
	},
	'tournament-onAir-on-svg': {
		name: 'tournament-onAir-on',
		filename: 'tournament-onAir-on.svg',
		path: 'onAir/tournament-onAir-on.svg',
		extension: 'svg',
		type: 'icon',
		category: 'onAir',
		assetDir: 'tournament',
	},
	'tournament-participate-off-svg': {
		name: 'tournament-participate-off',
		filename: 'tournament-participate-off.svg',
		path: 'participate/tournament-participate-off.svg',
		extension: 'svg',
		type: 'icon',
		category: 'participate',
		assetDir: 'tournament',
	},
	'tournament-participate-on-svg': {
		name: 'tournament-participate-on',
		filename: 'tournament-participate-on.svg',
		path: 'participate/tournament-participate-on.svg',
		extension: 'svg',
		type: 'icon',
		category: 'participate',
		assetDir: 'tournament',
	},
	'tournament-round-1024-active-png': {
		name: 'tournament-round-1024-active',
		filename: 'tournament-round-1024-active.png',
		path: 'round/1024/tournament-round-1024-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-1024-disabled-png': {
		name: 'tournament-round-1024-disabled',
		filename: 'tournament-round-1024-disabled.png',
		path: 'round/1024/tournament-round-1024-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-1024-enabled-png': {
		name: 'tournament-round-1024-enabled',
		filename: 'tournament-round-1024-enabled.png',
		path: 'round/1024/tournament-round-1024-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-128-active-png': {
		name: 'tournament-round-128-active',
		filename: 'tournament-round-128-active.png',
		path: 'round/128/tournament-round-128-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-128-disabled-png': {
		name: 'tournament-round-128-disabled',
		filename: 'tournament-round-128-disabled.png',
		path: 'round/128/tournament-round-128-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-128-enabled-png': {
		name: 'tournament-round-128-enabled',
		filename: 'tournament-round-128-enabled.png',
		path: 'round/128/tournament-round-128-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-16-active-png': {
		name: 'tournament-round-16-active',
		filename: 'tournament-round-16-active.png',
		path: 'round/16/tournament-round-16-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-16-disabled-png': {
		name: 'tournament-round-16-disabled',
		filename: 'tournament-round-16-disabled.png',
		path: 'round/16/tournament-round-16-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-16-enabled-png': {
		name: 'tournament-round-16-enabled',
		filename: 'tournament-round-16-enabled.png',
		path: 'round/16/tournament-round-16-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-256-active-png': {
		name: 'tournament-round-256-active',
		filename: 'tournament-round-256-active.png',
		path: 'round/256/tournament-round-256-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-256-disabled-png': {
		name: 'tournament-round-256-disabled',
		filename: 'tournament-round-256-disabled.png',
		path: 'round/256/tournament-round-256-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-256-enabled-png': {
		name: 'tournament-round-256-enabled',
		filename: 'tournament-round-256-enabled.png',
		path: 'round/256/tournament-round-256-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-32-active-png': {
		name: 'tournament-round-32-active',
		filename: 'tournament-round-32-active.png',
		path: 'round/32/tournament-round-32-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-32-disabled-png': {
		name: 'tournament-round-32-disabled',
		filename: 'tournament-round-32-disabled.png',
		path: 'round/32/tournament-round-32-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-32-enabled-png': {
		name: 'tournament-round-32-enabled',
		filename: 'tournament-round-32-enabled.png',
		path: 'round/32/tournament-round-32-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-512-active-png': {
		name: 'tournament-round-512-active',
		filename: 'tournament-round-512-active.png',
		path: 'round/512/tournament-round-512-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-512-disabled-png': {
		name: 'tournament-round-512-disabled',
		filename: 'tournament-round-512-disabled.png',
		path: 'round/512/tournament-round-512-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-512-enabled-png': {
		name: 'tournament-round-512-enabled',
		filename: 'tournament-round-512-enabled.png',
		path: 'round/512/tournament-round-512-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-64-active-png': {
		name: 'tournament-round-64-active',
		filename: 'tournament-round-64-active.png',
		path: 'round/64/tournament-round-64-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-64-disabled-png': {
		name: 'tournament-round-64-disabled',
		filename: 'tournament-round-64-disabled.png',
		path: 'round/64/tournament-round-64-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-64-enabled-png': {
		name: 'tournament-round-64-enabled',
		filename: 'tournament-round-64-enabled.png',
		path: 'round/64/tournament-round-64-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-8-active-png': {
		name: 'tournament-round-8-active',
		filename: 'tournament-round-8-active.png',
		path: 'round/8/tournament-round-8-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-8-disabled-png': {
		name: 'tournament-round-8-disabled',
		filename: 'tournament-round-8-disabled.png',
		path: 'round/8/tournament-round-8-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-8-enabled-png': {
		name: 'tournament-round-8-enabled',
		filename: 'tournament-round-8-enabled.png',
		path: 'round/8/tournament-round-8-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-finals-active-png': {
		name: 'tournament-round-finals-active',
		filename: 'tournament-round-finals-active.png',
		path: 'round/finals/tournament-round-finals-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-finals-disabled-png': {
		name: 'tournament-round-finals-disabled',
		filename: 'tournament-round-finals-disabled.png',
		path: 'round/finals/tournament-round-finals-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-finals-enabled-png': {
		name: 'tournament-round-finals-enabled',
		filename: 'tournament-round-finals-enabled.png',
		path: 'round/finals/tournament-round-finals-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-semi-active-png': {
		name: 'tournament-round-semi-active',
		filename: 'tournament-round-semi-active.png',
		path: 'round/semi/tournament-round-semi-active.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-semi-disabled-png': {
		name: 'tournament-round-semi-disabled',
		filename: 'tournament-round-semi-disabled.png',
		path: 'round/semi/tournament-round-semi-disabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-round-semi-enabled-png': {
		name: 'tournament-round-semi-enabled',
		filename: 'tournament-round-semi-enabled.png',
		path: 'round/semi/tournament-round-semi-enabled.png',
		extension: 'png',
		type: 'image',
		category: 'round',
		assetDir: 'tournament',
	},
	'tournament-status-basic-finished-png': {
		name: 'tournament-status-basic-finished',
		filename: 'tournament-status-basic-finished.png',
		path: 'status/basic/tournament-status-basic-finished.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-basic-live-png': {
		name: 'tournament-status-basic-live',
		filename: 'tournament-status-basic-live.png',
		path: 'status/basic/tournament-status-basic-live.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-basic-open-png': {
		name: 'tournament-status-basic-open',
		filename: 'tournament-status-basic-open.png',
		path: 'status/basic/tournament-status-basic-open.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-basic-setup-png': {
		name: 'tournament-status-basic-setup',
		filename: 'tournament-status-basic-setup.png',
		path: 'status/basic/tournament-status-basic-setup.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-basic-upcoming-png': {
		name: 'tournament-status-basic-upcoming',
		filename: 'tournament-status-basic-upcoming.png',
		path: 'status/basic/tournament-status-basic-upcoming.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-bubble-finished-png': {
		name: 'tournament-status-bubble-finished',
		filename: 'tournament-status-bubble-finished.png',
		path: 'status/bubble/tournament-status-bubble-finished.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-bubble-live-png': {
		name: 'tournament-status-bubble-live',
		filename: 'tournament-status-bubble-live.png',
		path: 'status/bubble/tournament-status-bubble-live.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-bubble-prematch-png': {
		name: 'tournament-status-bubble-prematch',
		filename: 'tournament-status-bubble-prematch.png',
		path: 'status/bubble/tournament-status-bubble-prematch.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-bubble-qualifier-png': {
		name: 'tournament-status-bubble-qualifier',
		filename: 'tournament-status-bubble-qualifier.png',
		path: 'status/bubble/tournament-status-bubble-qualifier.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-bubble-register-png': {
		name: 'tournament-status-bubble-register',
		filename: 'tournament-status-bubble-register.png',
		path: 'status/bubble/tournament-status-bubble-register.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-bubble-selecting-png': {
		name: 'tournament-status-bubble-selecting',
		filename: 'tournament-status-bubble-selecting.png',
		path: 'status/bubble/tournament-status-bubble-selecting.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-bubble-upcoming-png': {
		name: 'tournament-status-bubble-upcoming',
		filename: 'tournament-status-bubble-upcoming.png',
		path: 'status/bubble/tournament-status-bubble-upcoming.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-colored-live-png': {
		name: 'tournament-status-text-colored-live',
		filename: 'tournament-status-text-colored-live.png',
		path: 'status/text/colored/tournament-status-text-colored-live.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-colored-prematch-png': {
		name: 'tournament-status-text-colored-prematch',
		filename: 'tournament-status-text-colored-prematch.png',
		path: 'status/text/colored/tournament-status-text-colored-prematch.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-colored-qualifier-png': {
		name: 'tournament-status-text-colored-qualifier',
		filename: 'tournament-status-text-colored-qualifier.png',
		path: 'status/text/colored/tournament-status-text-colored-qualifier.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-colored-register-png': {
		name: 'tournament-status-text-colored-register',
		filename: 'tournament-status-text-colored-register.png',
		path: 'status/text/colored/tournament-status-text-colored-register.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-colored-selecting-png': {
		name: 'tournament-status-text-colored-selecting',
		filename: 'tournament-status-text-colored-selecting.png',
		path: 'status/text/colored/tournament-status-text-colored-selecting.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-colored-upcoming-png': {
		name: 'tournament-status-text-colored-upcoming',
		filename: 'tournament-status-text-colored-upcoming.png',
		path: 'status/text/colored/tournament-status-text-colored-upcoming.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-default-finished-png': {
		name: 'tournament-status-text-default-finished',
		filename: 'tournament-status-text-default-finished.png',
		path: 'status/text/default/tournament-status-text-default-finished.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-default-live-png': {
		name: 'tournament-status-text-default-live',
		filename: 'tournament-status-text-default-live.png',
		path: 'status/text/default/tournament-status-text-default-live.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-default-prematch-png': {
		name: 'tournament-status-text-default-prematch',
		filename: 'tournament-status-text-default-prematch.png',
		path: 'status/text/default/tournament-status-text-default-prematch.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-default-qualifier-png': {
		name: 'tournament-status-text-default-qualifier',
		filename: 'tournament-status-text-default-qualifier.png',
		path: 'status/text/default/tournament-status-text-default-qualifier.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-default-register-png': {
		name: 'tournament-status-text-default-register',
		filename: 'tournament-status-text-default-register.png',
		path: 'status/text/default/tournament-status-text-default-register.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-status-text-default-selecting-png': {
		name: 'tournament-status-text-default-selecting',
		filename: 'tournament-status-text-default-selecting.png',
		path: 'status/text/default/tournament-status-text-default-selecting.png',
		extension: 'png',
		type: 'image',
		category: 'status',
		assetDir: 'tournament',
	},
	'tournament-tab-biz-gray-svg': {
		name: 'tournament-tab-biz-gray',
		filename: 'tournament-tab-biz-gray.svg',
		path: 'tab/tournament-tab-biz-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-biz-purple-svg': {
		name: 'tournament-tab-biz-purple',
		filename: 'tournament-tab-biz-purple.svg',
		path: 'tab/tournament-tab-biz-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-feed-gray-svg': {
		name: 'tournament-tab-feed-gray',
		filename: 'tournament-tab-feed-gray.svg',
		path: 'tab/tournament-tab-feed-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-feed-purple-svg': {
		name: 'tournament-tab-feed-purple',
		filename: 'tournament-tab-feed-purple.svg',
		path: 'tab/tournament-tab-feed-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-home-gray-svg': {
		name: 'tournament-tab-home-gray',
		filename: 'tournament-tab-home-gray.svg',
		path: 'tab/tournament-tab-home-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-home-purple-svg': {
		name: 'tournament-tab-home-purple',
		filename: 'tournament-tab-home-purple.svg',
		path: 'tab/tournament-tab-home-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-my-gray-svg': {
		name: 'tournament-tab-my-gray',
		filename: 'tournament-tab-my-gray.svg',
		path: 'tab/tournament-tab-my-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-my-purple-svg': {
		name: 'tournament-tab-my-purple',
		filename: 'tournament-tab-my-purple.svg',
		path: 'tab/tournament-tab-my-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-ranking-gray-svg': {
		name: 'tournament-tab-ranking-gray',
		filename: 'tournament-tab-ranking-gray.svg',
		path: 'tab/tournament-tab-ranking-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-ranking-purple-svg': {
		name: 'tournament-tab-ranking-purple',
		filename: 'tournament-tab-ranking-purple.svg',
		path: 'tab/tournament-tab-ranking-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-trophy-gray-svg': {
		name: 'tournament-tab-trophy-gray',
		filename: 'tournament-tab-trophy-gray.svg',
		path: 'tab/tournament-tab-trophy-gray.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-trophy-purple-svg': {
		name: 'tournament-tab-trophy-purple',
		filename: 'tournament-tab-trophy-purple.svg',
		path: 'tab/tournament-tab-trophy-purple.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tab-trophy-white-svg': {
		name: 'tournament-tab-trophy-white',
		filename: 'tournament-tab-trophy-white.svg',
		path: 'tab/tournament-tab-trophy-white.svg',
		extension: 'svg',
		type: 'icon',
		category: 'tab',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-3rd-place-png': {
		name: 'tournament-tournament-basic-3rd-place',
		filename: 'tournament-tournament-basic-3rd-place.png',
		path: 'tournament/basic/tournament-tournament-basic-3rd-place.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-3rd-title-png': {
		name: 'tournament-tournament-basic-3rd-title',
		filename: 'tournament-tournament-basic-3rd-title.png',
		path: 'tournament/basic/tournament-tournament-basic-3rd-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-3rd-win-png': {
		name: 'tournament-tournament-basic-3rd-win',
		filename: 'tournament-tournament-basic-3rd-win.png',
		path: 'tournament/basic/tournament-tournament-basic-3rd-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-3rd-winner-png': {
		name: 'tournament-tournament-basic-3rd-winner',
		filename: 'tournament-tournament-basic-3rd-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-3rd-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-3rd-png': {
		name: 'tournament-tournament-basic-3rd',
		filename: 'tournament-tournament-basic-3rd.png',
		path: 'tournament/basic/tournament-tournament-basic-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-early-title-png': {
		name: 'tournament-tournament-basic-early-title',
		filename: 'tournament-tournament-basic-early-title.png',
		path: 'tournament/basic/tournament-tournament-basic-early-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-early-win-png': {
		name: 'tournament-tournament-basic-early-win',
		filename: 'tournament-tournament-basic-early-win.png',
		path: 'tournament/basic/tournament-tournament-basic-early-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-early-winner-png': {
		name: 'tournament-tournament-basic-early-winner',
		filename: 'tournament-tournament-basic-early-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-early-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-early-png': {
		name: 'tournament-tournament-basic-early',
		filename: 'tournament-tournament-basic-early.png',
		path: 'tournament/basic/tournament-tournament-basic-early.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-eighth-title-png': {
		name: 'tournament-tournament-basic-eighth-title',
		filename: 'tournament-tournament-basic-eighth-title.png',
		path: 'tournament/basic/tournament-tournament-basic-eighth-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-eighth-win-png': {
		name: 'tournament-tournament-basic-eighth-win',
		filename: 'tournament-tournament-basic-eighth-win.png',
		path: 'tournament/basic/tournament-tournament-basic-eighth-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-eighth-winner-png': {
		name: 'tournament-tournament-basic-eighth-winner',
		filename: 'tournament-tournament-basic-eighth-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-eighth-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-eighth-png': {
		name: 'tournament-tournament-basic-eighth',
		filename: 'tournament-tournament-basic-eighth.png',
		path: 'tournament/basic/tournament-tournament-basic-eighth.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-finals-title-png': {
		name: 'tournament-tournament-basic-finals-title',
		filename: 'tournament-tournament-basic-finals-title.png',
		path: 'tournament/basic/tournament-tournament-basic-finals-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-finals-win-png': {
		name: 'tournament-tournament-basic-finals-win',
		filename: 'tournament-tournament-basic-finals-win.png',
		path: 'tournament/basic/tournament-tournament-basic-finals-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-finals-winner-png': {
		name: 'tournament-tournament-basic-finals-winner',
		filename: 'tournament-tournament-basic-finals-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-finals-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-finals-png': {
		name: 'tournament-tournament-basic-finals',
		filename: 'tournament-tournament-basic-finals.png',
		path: 'tournament/basic/tournament-tournament-basic-finals.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-first-title-png': {
		name: 'tournament-tournament-basic-first-title',
		filename: 'tournament-tournament-basic-first-title.png',
		path: 'tournament/basic/tournament-tournament-basic-first-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-first-win-png': {
		name: 'tournament-tournament-basic-first-win',
		filename: 'tournament-tournament-basic-first-win.png',
		path: 'tournament/basic/tournament-tournament-basic-first-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-first-winner-png': {
		name: 'tournament-tournament-basic-first-winner',
		filename: 'tournament-tournament-basic-first-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-first-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-first-png': {
		name: 'tournament-tournament-basic-first',
		filename: 'tournament-tournament-basic-first.png',
		path: 'tournament/basic/tournament-tournament-basic-first.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-late-title-png': {
		name: 'tournament-tournament-basic-late-title',
		filename: 'tournament-tournament-basic-late-title.png',
		path: 'tournament/basic/tournament-tournament-basic-late-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-late-win-png': {
		name: 'tournament-tournament-basic-late-win',
		filename: 'tournament-tournament-basic-late-win.png',
		path: 'tournament/basic/tournament-tournament-basic-late-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-late-winner-png': {
		name: 'tournament-tournament-basic-late-winner',
		filename: 'tournament-tournament-basic-late-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-late-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-late-png': {
		name: 'tournament-tournament-basic-late',
		filename: 'tournament-tournament-basic-late.png',
		path: 'tournament/basic/tournament-tournament-basic-late.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-middle-title-png': {
		name: 'tournament-tournament-basic-middle-title',
		filename: 'tournament-tournament-basic-middle-title.png',
		path: 'tournament/basic/tournament-tournament-basic-middle-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-middle-win-png': {
		name: 'tournament-tournament-basic-middle-win',
		filename: 'tournament-tournament-basic-middle-win.png',
		path: 'tournament/basic/tournament-tournament-basic-middle-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-middle-winner-png': {
		name: 'tournament-tournament-basic-middle-winner',
		filename: 'tournament-tournament-basic-middle-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-middle-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-middle-png': {
		name: 'tournament-tournament-basic-middle',
		filename: 'tournament-tournament-basic-middle.png',
		path: 'tournament/basic/tournament-tournament-basic-middle.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-pre-semi-title-png': {
		name: 'tournament-tournament-basic-pre-semi-title',
		filename: 'tournament-tournament-basic-pre-semi-title.png',
		path: 'tournament/basic/tournament-tournament-basic-pre-semi-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-pre-semi-win-png': {
		name: 'tournament-tournament-basic-pre-semi-win',
		filename: 'tournament-tournament-basic-pre-semi-win.png',
		path: 'tournament/basic/tournament-tournament-basic-pre-semi-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-pre-semi-winner-png': {
		name: 'tournament-tournament-basic-pre-semi-winner',
		filename: 'tournament-tournament-basic-pre-semi-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-pre-semi-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-pre-semi-png': {
		name: 'tournament-tournament-basic-pre-semi',
		filename: 'tournament-tournament-basic-pre-semi.png',
		path: 'tournament/basic/tournament-tournament-basic-pre-semi.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-preliminary-title-png': {
		name: 'tournament-tournament-basic-preliminary-title',
		filename: 'tournament-tournament-basic-preliminary-title.png',
		path: 'tournament/basic/tournament-tournament-basic-preliminary-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-preliminary-win-png': {
		name: 'tournament-tournament-basic-preliminary-win',
		filename: 'tournament-tournament-basic-preliminary-win.png',
		path: 'tournament/basic/tournament-tournament-basic-preliminary-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-preliminary-winner-png': {
		name: 'tournament-tournament-basic-preliminary-winner',
		filename: 'tournament-tournament-basic-preliminary-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-preliminary-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-preliminary-png': {
		name: 'tournament-tournament-basic-preliminary',
		filename: 'tournament-tournament-basic-preliminary.png',
		path: 'tournament/basic/tournament-tournament-basic-preliminary.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-quarter-title-png': {
		name: 'tournament-tournament-basic-quarter-title',
		filename: 'tournament-tournament-basic-quarter-title.png',
		path: 'tournament/basic/tournament-tournament-basic-quarter-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-quarter-win-png': {
		name: 'tournament-tournament-basic-quarter-win',
		filename: 'tournament-tournament-basic-quarter-win.png',
		path: 'tournament/basic/tournament-tournament-basic-quarter-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-quarter-winner-png': {
		name: 'tournament-tournament-basic-quarter-winner',
		filename: 'tournament-tournament-basic-quarter-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-quarter-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-quarter-png': {
		name: 'tournament-tournament-basic-quarter',
		filename: 'tournament-tournament-basic-quarter.png',
		path: 'tournament/basic/tournament-tournament-basic-quarter.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-semi-title-png': {
		name: 'tournament-tournament-basic-semi-title',
		filename: 'tournament-tournament-basic-semi-title.png',
		path: 'tournament/basic/tournament-tournament-basic-semi-title.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-semi-win-png': {
		name: 'tournament-tournament-basic-semi-win',
		filename: 'tournament-tournament-basic-semi-win.png',
		path: 'tournament/basic/tournament-tournament-basic-semi-win.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-semi-winner-png': {
		name: 'tournament-tournament-basic-semi-winner',
		filename: 'tournament-tournament-basic-semi-winner.png',
		path: 'tournament/basic/tournament-tournament-basic-semi-winner.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-semi-png': {
		name: 'tournament-tournament-basic-semi',
		filename: 'tournament-tournament-basic-semi.png',
		path: 'tournament/basic/tournament-tournament-basic-semi.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-basic-title-match-finals-png': {
		name: 'tournament-tournament-basic-title-match-finals',
		filename: 'tournament-tournament-basic-title-match-finals.png',
		path: 'tournament/basic/tournament-tournament-basic-title-match-finals.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-1st-png': {
		name: 'tournament-tournament-rank-1st',
		filename: 'tournament-tournament-rank-1st.png',
		path: 'tournament/rank/tournament-tournament-rank-1st.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-2nd-png': {
		name: 'tournament-tournament-rank-2nd',
		filename: 'tournament-tournament-rank-2nd.png',
		path: 'tournament/rank/tournament-tournament-rank-2nd.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-3rd-png': {
		name: 'tournament-tournament-rank-3rd',
		filename: 'tournament-tournament-rank-3rd.png',
		path: 'tournament/rank/tournament-tournament-rank-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-4th-png': {
		name: 'tournament-tournament-rank-4th',
		filename: 'tournament-tournament-rank-4th.png',
		path: 'tournament/rank/tournament-tournament-rank-4th.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-finished-1st-png': {
		name: 'tournament-tournament-rank-finished-1st',
		filename: 'tournament-tournament-rank-finished-1st.png',
		path: 'tournament/rank/tournament-tournament-rank-finished-1st.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-finished-2nd-png': {
		name: 'tournament-tournament-rank-finished-2nd',
		filename: 'tournament-tournament-rank-finished-2nd.png',
		path: 'tournament/rank/tournament-tournament-rank-finished-2nd.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-finished-3rd-png': {
		name: 'tournament-tournament-rank-finished-3rd',
		filename: 'tournament-tournament-rank-finished-3rd.png',
		path: 'tournament/rank/tournament-tournament-rank-finished-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-finished-4th-png': {
		name: 'tournament-tournament-rank-finished-4th',
		filename: 'tournament-tournament-rank-finished-4th.png',
		path: 'tournament/rank/tournament-tournament-rank-finished-4th.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-finished-modal-1st-png': {
		name: 'tournament-tournament-rank-finished-modal-1st',
		filename: 'tournament-tournament-rank-finished-modal-1st.png',
		path: 'tournament/rank/tournament-tournament-rank-finished-modal-1st.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-finished-modal-2nd-png': {
		name: 'tournament-tournament-rank-finished-modal-2nd',
		filename: 'tournament-tournament-rank-finished-modal-2nd.png',
		path: 'tournament/rank/tournament-tournament-rank-finished-modal-2nd.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-finished-modal-3rd-png': {
		name: 'tournament-tournament-rank-finished-modal-3rd',
		filename: 'tournament-tournament-rank-finished-modal-3rd.png',
		path: 'tournament/rank/tournament-tournament-rank-finished-modal-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-tournament-rank-finished-modal-4th-png': {
		name: 'tournament-tournament-rank-finished-modal-4th',
		filename: 'tournament-tournament-rank-finished-modal-4th.png',
		path: 'tournament/rank/tournament-tournament-rank-finished-modal-4th.png',
		extension: 'png',
		type: 'image',
		category: 'tournament',
		assetDir: 'tournament',
	},
	'tournament-video-1st-png': {
		name: 'tournament-video-1st',
		filename: 'tournament-video-1st.png',
		path: 'video/tournament-video-1st.png',
		extension: 'png',
		type: 'image',
		category: 'video',
		assetDir: 'tournament',
	},
	'tournament-video-2nd-png': {
		name: 'tournament-video-2nd',
		filename: 'tournament-video-2nd.png',
		path: 'video/tournament-video-2nd.png',
		extension: 'png',
		type: 'image',
		category: 'video',
		assetDir: 'tournament',
	},
	'tournament-video-3rd-png': {
		name: 'tournament-video-3rd',
		filename: 'tournament-video-3rd.png',
		path: 'video/tournament-video-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'video',
		assetDir: 'tournament',
	},
	'tournament-vs-3rd-png': {
		name: 'tournament-vs-3rd',
		filename: 'tournament-vs-3rd.png',
		path: 'vs/tournament-vs-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'vs',
		assetDir: 'tournament',
	},
	'tournament-vs-finals-png': {
		name: 'tournament-vs-finals',
		filename: 'tournament-vs-finals.png',
		path: 'vs/tournament-vs-finals.png',
		extension: 'png',
		type: 'image',
		category: 'vs',
		assetDir: 'tournament',
	},
	'tournament-vs-vs-png': {
		name: 'tournament-vs-vs',
		filename: 'tournament-vs-vs.png',
		path: 'vs/tournament-vs-vs.png',
		extension: 'png',
		type: 'image',
		category: 'vs',
		assetDir: 'tournament',
	},
	'tournament-winner-3rd-png': {
		name: 'tournament-winner-3rd',
		filename: 'tournament-winner-3rd.png',
		path: 'winner/tournament-winner-3rd.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-finals-png': {
		name: 'tournament-winner-finals',
		filename: 'tournament-winner-finals.png',
		path: 'winner/tournament-winner-finals.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-r1024-png': {
		name: 'tournament-winner-r1024',
		filename: 'tournament-winner-r1024.png',
		path: 'winner/tournament-winner-r1024.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-r128-png': {
		name: 'tournament-winner-r128',
		filename: 'tournament-winner-r128.png',
		path: 'winner/tournament-winner-r128.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-r16-png': {
		name: 'tournament-winner-r16',
		filename: 'tournament-winner-r16.png',
		path: 'winner/tournament-winner-r16.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-r256-png': {
		name: 'tournament-winner-r256',
		filename: 'tournament-winner-r256.png',
		path: 'winner/tournament-winner-r256.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-r32-png': {
		name: 'tournament-winner-r32',
		filename: 'tournament-winner-r32.png',
		path: 'winner/tournament-winner-r32.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-r512-png': {
		name: 'tournament-winner-r512',
		filename: 'tournament-winner-r512.png',
		path: 'winner/tournament-winner-r512.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-r64-png': {
		name: 'tournament-winner-r64',
		filename: 'tournament-winner-r64.png',
		path: 'winner/tournament-winner-r64.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-r8-png': {
		name: 'tournament-winner-r8',
		filename: 'tournament-winner-r8.png',
		path: 'winner/tournament-winner-r8.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
	'tournament-winner-semi-png': {
		name: 'tournament-winner-semi',
		filename: 'tournament-winner-semi.png',
		path: 'winner/tournament-winner-semi.png',
		extension: 'png',
		type: 'image',
		category: 'winner',
		assetDir: 'tournament',
	},
};

// 유틸리티 타입들은 필요에 따라 추가할 수 있습니다.
